<template>
  <div class="close-header-title no-con">
    <section class="pt_large pb_large shop-inner-section">
      <div class="container mb-px-0">
        <div class="card mb-py-0">
          <div class="container-fliud">
            <div class="wrapper row m-0">
              <div class="d-none d-md-block" style="width: 100%;">
                <div class="preview col-md-12 p-0">
                  <div class="row thumbnail-holder m-0">
                    <div class="col-lg-6 p-0">
                      <div class="thumbnail-img">
                        <a v-if="property.photos && property.photos.length > 0" :href="property.photos[0].path"
                          data-fancybox="gallery">
                          <img :src="property.photos[0].path" alt="image" class="property-gallery-image" />
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-3 p-0">
                      <div class="thumbnail-img" v-for="(image, index) in property.photos.slice(1, 3)"
                        :key="'thumb-' + index">
                        <a :href="image.path" data-fancybox="gallery">
                          <img :src="image.path" alt="image" class="property-gallery-image" />
                        </a>
                      </div>
                    </div>
                    <div class="col-lg-3 p-0">
                      <div class="thumbnail-img" v-for="(image, index) in property.photos.slice(3, 5)"
                        :key="'thumb-' + index">
                        <a :href="image.path" data-fancybox="gallery">
                          <img :src="image.path" alt="image" class="property-gallery-image" />
                        </a>
                      </div>
                      <div style="display: none;">
                        <a v-for="(image, index) in property.photos.slice(5)" :key="'hidden-thumb-' + index"
                          :href="image.path" data-fancybox="gallery"></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="w-100 d-md-none position-relative mb-3">
                <div class="w-100 mobile-property-carousel-container">
                  <b-carousel id="carousel-mobile" v-model="currentSlide" :interval="0" controls
                    background="#000" style="border-radius: 12px; overflow: hidden;">
                    <b-carousel-slide v-for="(photo, index) in property.photos" :key="index">
                      <template #img>
                        <a :href="photo.path" data-fancybox="gallery" class="mobile-gallery-link">
                          <img
                            :src="photo.path"
                            alt="Property photo"
                            class="d-block w-100 mobile-property-detail-img"
                          />
                        </a>
                      </template>
                    </b-carousel-slide>
                  </b-carousel>
                  <div class="mobile-photo-badge" v-if="property.photos && property.photos.length > 0">
                    <i class="fa fa-camera mr-1"></i> {{ currentSlide + 1 }} / {{ property.photos.length }}
                  </div>
                </div>
              </div>
              <div :class="{ sticky: isSticky }" class="tabs-list vue-tabslist px-0 mb-px-20">
                <b-card no-body>
                  <b-tabs card>
                    <b-tab :title="$t('Propertis.Overview')" active>
                      <div class="product-detail-sec">
                        <div class="row">
                          <div class="details details-section col-xl-8 col-lg-7">
                            <h1 class="product-title">
                              {{ $t('property_detail.' + property.property_type) }}
                              {{ $t('property_detail.accommodation_types.' + property.accommodation_type) }}
                              {{ $t('property_detail.in_city_country', {
                                city: property.city, country: property.country
                              }) }}
                            </h1>
                            <div class="popular-amenities">
                              <h3>{{ $t('Propertis.Amenities') }}</h3>
                              <ul>
                                <li>
                                  <div class="air-condition">
                                    <span><i class="fa fa-bed" aria-hidden="true"></i></span>
                                    <span>{{ property.num_bedrooms }} {{ bedroomLabel }}</span>
                                  </div>
                                </li>
                                <li v-if="property.kitchen_available === 1">
                                  <div class="air-condition">
                                    <span><i class="fas fa-utensils"></i></span>
                                    <span>{{ $t('Propertis.Kitchen') }}</span>
                                  </div>
                                </li>
                                <li v-if="property.tv_available === 1">
                                  <div class="air-condition">
                                    <span><i class="fa fa-tv" aria-hidden="true"></i></span>
                                    <span>{{ $t('Propertis.TV') }}</span>
                                  </div>
                                </li>
                                <li v-if="property.wifi_available === 1">
                                  <div class="air-condition">
                                    <span><i class="fa fa-wifi" aria-hidden="true"></i></span>
                                    <span>{{ $t('Propertis.Wifi') }}</span>
                                  </div>
                                </li>
                                <li>
                                  <div class="air-condition">
                                    <span><i class="fa fa-bath" aria-hidden="true"></i></span>
                                    <span>{{ property.num_bathrooms }} {{ bathroomLabel }}</span>
                                  </div>
                                </li>
                              </ul>
                              <b-button type="button" class="see-all-btn" v-b-modal.modal-scrollable>
                                <span aria-hidden="true" class="font-weight-bold mr-2">{{ $t('Propertis.See_all') }}</span>
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </b-button>
                            </div>
                            <div class="explore-area">
                              <h3 class="font-weight-bold  mb-3">{{ $t('Propertis.explore') }}</h3>
                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="map-sec" ref="map" style="height: 200px;"></div>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div class="col-xl-4 col-lg-5 relative">

                            <div class="pricing-detail-box flex-pricing-detail-box mb-5 mb-lg-0">
                              <!-- Discounted Price Display -->
                              <div v-if="pfDisprice" class="strikethrough">
                                <h2 style="margin-bottom: -15px;">
                                  {{ currency }} {{ totaldicPrice1 === 0 ? pfDisprice : totaldicPrice1 }}
                                </h2>
                                <!-- Discount Percentage Badge -->
                                <div v-if="property.discountpersentage != null" class="favorite-button-discount">
                                  <span class="checked-span">-{{ property.discountpersentage }}%</span>
                                </div>
                              </div>
                              <br>

                              <!-- Regular Price Display -->
                              <div class="heading">
                                <!-- Loading State -->
                                <span v-if="loading">
                                  <img :src="loaderGif" alt="Loading..." class="loading-gif" />
                                </span>

                                <!-- Price Display -->
                                <template v-else>
                                  <h2 class="font-weight-bold">
                                    {{ currency }} 
                                    {{ getDisplayPrice }}/<span class="text-xlightgrey font-weight-normal">{{ getPricePeriod }}</span>
                                  </h2>
                                </template>
                              </div>
                              <div class="date-pricing">
                                <svg v-b-tooltip.hover :title="$t('tooltips.full_refund_hint')"
                                  class="uitk-icon uitk-spacing uitk-spacing-margin-inlineend-two uitk-icon-small uitk-icon-negative-theme"
                                  aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <path
                                    d="M12 17.042a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-3.396a.75.75 0 0 0 .75-.75V7.783a.75.75 0 1 0-1.5 0v5.113c0 .415.336.75.75.75z">
                                  </path>
                                  <path
                                    d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18.5c-4.687 0-8.5-3.813-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5z">
                                  </path>
                                </svg>
                                <span class="font-weight-bold">{{ $t('Propertis.Full_refund') }}</span>
                              </div>
                              <form action="#" class="payment-form for-custom-style">
                                <div class="">
                                  <div class="form-field">
                                    <div class="date-picker" style="display: none;">
                                      <date-range-picker v-model="dateRange" :format="format" :placeholder="placeholder"
                                        :date-format="dateFormat" :ranges='false' :locale-data="locale_data"
                                        :key="localeKey" :min-date="today" />

                                    </div>
                                  </div>
                                  <div class="form-field">
                                    <div class="date-picker  date-field-selection">
                                      <date-range-picker v-model="dateRange" ref="datePickerRef" :min-date="today"
                                        :format="format" :placeholder="placeholder" :date-format="dateFormat"
                                        :ranges='false' :locale-data="locale_data" :key="localeKey" />
                                    </div>
                                  </div>
                                  <div class="accordian-guests">
                                    <div class="form-field" ref="toggle5" @click="togglePopup5">
                                      <p class="form-control" style="padding: 12px 14px; border-radius: 10px;">
                                        {{ property.max_guests }} {{ property.max_guests === 1 ? $t('Propertis.Guest') :
                                          $t('Propertis.Guests') }}
                                      </p>
                                    </div>
                                    <div class="popup-guest" v-if="isPopupVisible5" ref="popup5">
                                      <div class="guest-content">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="decrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="1.00" v-model="property.max_guests"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="increment">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>

                                      <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="childDecrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="0.00" :value="childQuantity"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="childIncrement">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="petDecrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="0.00" :value="petQuantity"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="petIncrement">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-btn mt-3">
                                  <button class="availbility-btn" type="button" @click="redirectToPayment"
                                    :disabled="loading">{{
                                      $t('property_detail.request_button') }}</button>
                                  <!-- <button v-if="!hasMadeOffer" class="availbility-btn mt-2" type="button"
                                    @click="sharedViewModal">
                                    {{ $t('Propertis.make_custom_offer') }}
                                  </button> -->
                                  <button v-if="hasMadeOffer" class="availbility-btn mt-2" type="button"
                                    @click="viewMyOffers">
                                    {{ $t('Propertis.my_offers') }}
                                  </button>
                                </div>

                                <div>
                                  <b-modal id="shared-modal" centered ref="shared-modal" scrollable
                                    :title="computedTitle" size="lg" :hide-footer="true">
                                    <div class="body-content shared-form-fields px-1 px-md-4 py-1">
                                      <form @submit.prevent="submitOffer" class="for-custom-style">
                                        <div class="mb-3" style="float: right;">
                                          <p>{{ $t('property_detail.offers_message', { attempts: remainingAttempts }) }}
                                          </p>
                                        </div>

                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="">{{ $t('offers.number_of_guests') }}</label>
                                          </div>
                                          <div>
                                            <div class="accordian-guests">
                                              <div class="form-field" ref="toggle4" @click="togglePopup4">
                                                <p class="form-control" style="border-radius: 10px;">
                                                  {{ property.max_guests }} {{ property.max_guests === 1 ?
                                                    $t('Propertis.Guest') :
                                                    $t('Propertis.Guests') }}
                                                </p>
                                              </div>
                                              <div class="popup-guest" v-if="isPopupVisible4" ref="popup4">
                                                <div class="guest-content">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="decrement">-</b-btn>
                                                          </b-input-group-prepend>

                                                          <b-form-input type="number" min="1.00"
                                                            v-model="property.max_guests" readonly></b-form-input>

                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="increment">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                                <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="childDecrement">-</b-btn>
                                                          </b-input-group-prepend>

                                                          <b-form-input type="number" min="0.00" :value="childQuantity"
                                                            readonly></b-form-input>

                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="childIncrement">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                                <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="petDecrement">-</b-btn>
                                                          </b-input-group-prepend>

                                                          <b-form-input type="number" min="0.00" :value="petQuantity"
                                                            readonly></b-form-input>

                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="petIncrement">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="">{{ $t('offers.stay_duration') }}</label>
                                          </div>
                                          <div class="date-picker">
                                            <date-range-picker v-model="dateRange" :min-date="today" :format="format"
                                              :placeholder="placeholder" :date-format="dateFormat" :ranges='false'
                                              :locale-data="locale_data" :key="localeKey" class="mb-0" />
                                          </div>
                                        </div>
                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="">{{ $t('offers.original_calculated_price') }}</label>
                                          </div>
                                          <input v-if="totalPrice1" type="text" name="" id=""
                                            :value="currency + ' ' + totalPrice1" disabled>
                                          <input v-else type="text" name="" id=""
                                            :value="currency + ' ' + pfprice + '/' + $t('property_detail.night').toLowerCase()"
                                            disabled>
                                        </div>
                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="offerPrice">{{ $t('offers.offer_your_price') }}<span
                                                style="color: red;">*</span></label>
                                          </div>
                                          <div class="remove-border">
                                            <input type="number" name="offerPrice" id="offerPrice"
                                              v-model.number="offeredPrice" @input="validateOfferPrice"
                                              :disabled="totalPrice1 <= 0"
                                              :placeholder="totalPrice1 <= 0 ? $t('Propertis.select_dates_first') : $t('Propertis.enter_your_offer')" />
                                            <div v-if="offerPriceError && offerPriceError.length"
                                              class="invalid-feedback offerPriceError">
                                              <div v-for="error in offerPriceError" :key="error">{{ error }}</div>
                                            </div>
                                            <!-- Better error display -->
                                            <div v-if="offerPriceError && offerPriceError.length"
                                              class="text-danger mt-2">
                                              <small v-for="error in offerPriceError" :key="error">{{ error }}</small>
                                            </div>

                                            <!-- Friendly hint when no dates selected -->
                                            <div v-else-if="totalPrice1 <= 0" class="text-muted mt-2">
                                              <small>{{ $t('Propertis.select_dates_to_see_price') }}</small>
                                            </div>
                                          </div>
                                        </div>
                                        <p class="description mb-5">
                                          {{ $t('offers.cannot_be_less_than') }} <span>30%</span> {{
                                            $t('offers.of_property_value') }}
                                        </p>
                                        <div class="footer-bottom form-btn">
                                          <button class="availbility-btn mt-2 card-blue-btn p-3" type="submit">
                                            <span v-if="isLoading">{{ $t('common.submitting') }}</span>
                                            <span v-else>{{ $t('common.submit') }}</span>
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                  </b-modal>
                                </div>
                                <!-- -------------------------- -->
                                <div>
                                  <b-modal id="my-offers-modal" class="offer-new-modal" centered ref="my-offers-modal"
                                    scrollable :title="$t('offers.my_offers')" size="lg" :hide-footer="true">
                                    <!-- Tabs Section -->
                                    <b-tabs v-model="activeTab" class="my-offer-tabs">
                                      <!-- My Offers Tab -->
                                      <b-tab :title="$t('offers.my_offers')" active>
                                        <div class="offer-detail-modal-table">
                                          <div class="card">
                                            <div class="card-header">
                                              <h4 class="card-title m-0">{{ $t('offers.made_today') }}</h4>
                                              <h5 class="card-title m-0" style="float: right;">
                                                {{ $t('offers.remaining_attempts') }}: {{ remainingAttempts }}
                                              </h5>
                                            </div>
                                            <div class="card-body">
                                              <div v-if="showMakeAnotherOffer" class="text-center mb-3">
                                                <button class="make-another-offer-btn" @click="makeAnotherOffer">
                                                  {{ $t('offers.make_another_offer') }}
                                                </button>
                                              </div>
                                              <div class="table-responsive">
                                                <table class="table">
                                                  <thead>
                                                    <tr>
                                                      <th>{{ $t('offers.offer_id') }}</th>
                                                      <th>{{ $t('offers.customer_name') }}</th>
                                                      <th>{{ $t('offers.property_type') }}</th>
                                                      <th>
                                                        {{ $t('offers.total_price') }}
                                                        <span class="tooltip-container ml-1">
                                                          <span class="info-icon">ℹ️</span>
                                                          <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                          }}</span>
                                                        </span>
                                                      </th>
                                                      <th>{{ $t('offers.offered_price') }}</th>
                                                      <th>{{ $t('offers.price_difference_pct') }}</th>
                                                      <th>{{ $t('offers.offer_status') }}</th>
                                                      <th>{{ $t('Propertis.start_date') }}</th>
                                                      <th>{{ $t('Propertis.end_date') }}</th>
                                                      <th>{{ $t('offers.action') }}</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr v-for="offer in offersData" :key="offer.id">
                                                      <td>{{ offer.offer_id }}</td>
                                                      <td>{{ offer.user.name }}</td>
                                                      <td>{{ offer.property.property_type }}</td>
                                                      <td>{{ offer.currency }} {{ offer.original_price }}</td>
                                                      <td>{{ offer.currency }} {{ offer.offered_price }}</td>
                                                      <td>{{ offer.price_difference_percentage }}%</td>
                                                      <td>{{ translateOfferStatusTable(offer.status) }}</td>
                                                      <td>{{ formatDate(offer.start_date) }}</td>
                                                      <td>{{ formatDate(offer.end_date) }}</td>
                                                      <td>
                                                        <button v-if="offer.status === 'accepted' && !offer.is_booked"
                                                          class="btn btn-primary" @click="bookNow(offer)">
                                                          {{ $t('offers.book_now') }}
                                                        </button>
                                                        <span v-else>
                                                          {{ offer.is_booked ? $t('offers.booked') :
                                                            translateOfferStatusTable(offer.status) }}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    <tr v-if="!offersData.length">
                                                      <td colspan="8">{{ $t('offers.none_today') }}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </b-tab>

                                      <!-- Previous Offers Tab -->
                                      <b-tab :title="$t('offers.previous_offers')">
                                        <div class="offer-detail-modal-table">
                                          <div class="card">
                                            <div class="card-header">
                                              <h4 class="card-title m-0">{{ $t('offers.previous_offers') }}</h4>
                                            </div>
                                            <div class="card-body">
                                              <div class="table-responsive">
                                                <table class="table">
                                                  <thead>
                                                    <tr>
                                                      <th>{{ $t('offers.offer_id') }}</th>
                                                      <th>{{ $t('offers.customer_name') }}</th>
                                                      <th>{{ $t('offers.property_type') }}</th>
                                                      <th>
                                                        {{ $t('offers.total_price') }}
                                                        <span class="tooltip-container ml-1">
                                                          <span class="info-icon">ℹ️</span>
                                                          <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                          }}</span>
                                                        </span>
                                                      </th>
                                                      <th>{{ $t('offers.offered_price') }}</th>
                                                      <th>{{ $t('offers.price_difference_pct') }}</th>
                                                      <th>{{ $t('offers.offer_status') }}</th>
                                                      <th>{{ $t('Propertis.start_date') }}</th>
                                                      <th>{{ $t('Propertis.end_date') }}</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr v-for="offer in previousOffersData" :key="offer.id">
                                                      <td>{{ offer.offer_id }}</td>
                                                      <td>{{ offer.user.name }}</td>
                                                      <td>{{ offer.property.property_type }}</td>
                                                      <td>{{ offer.currency }} {{ offer.original_price }}</td>
                                                      <td>{{ offer.currency }} {{ offer.offered_price }}</td>
                                                      <td>{{ offer.price_difference_percentage }}%</td>
                                                      <td>{{ translateOfferStatusTable(offer.status) }}</td>
                                                      <td>{{ formatDate(offer.start_date) }}</td>
                                                      <td>{{ formatDate(offer.end_date) }}</td>
                                                    </tr>
                                                    <tr v-if="!previousOffersData.length">
                                                      <td colspan="6">{{ $t('offers.none_previous') }}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                              <b-pagination v-if="totalPreviousOffers > perPage"
                                                :total-rows="totalPreviousOffers" :per-page="perPage"
                                                v-model="currentPage" @change="onPageChange"></b-pagination>
                                            </div>
                                          </div>
                                        </div>
                                      </b-tab>

                                    </b-tabs>
                                  </b-modal>
                                </div>
                              </form>
                            
                              <div v-if="longdis">
                                <div class="timer favorite-button-discount"><span class="checked-span">-{{ longdis
                                }}%</span>
                                </div>
                              </div>
                              <div v-else-if="pfDisprice && showTimer">
                                <div class="timer">
                                  <span>{{ $t('offers.offer_ends_in') }}</span> <span>{{ formattedTime }}</span>
                                </div>
                              </div>
                              <div v-else-if="flashDiscount && showTimer">
                                <div class="timer">
                                  <span>{{ $t('offers.offer_ends_in') }}</span> <span>{{ formattedTime }}</span>
                                </div>
                              </div>
                                <div class="detail-sidebar-icons-boxes py-4">
                                <div class="d-flex align-items-center mb-4">
                                  <div class="mr-3 icon-box">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                          <path d="M9.5 12.4L10.9286 14L14.5 10" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 14.4963 20.1632 16.4284 19 17.9041M3.19284 14C4.05026 18.2984 7.57641 20.5129 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C14.6796 21.2747 15.3324 20.9478 16 20.5328" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                  </div>
                                  <div>
                                     <h5 class="mb-1 font-weight-bold">{{ $t('common.verified_listings') }}</h5>
                                     <p class="m-0">{{ $t('common.all_properties_are_checked') }}</p>
                                  </div>
                                 </div>

                                 <div class="d-flex align-items-center mb-4">
                                      <div class="mr-3 icon-box">
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                              <path d="M3.5 9.398C3.5 8.37292 3.5 7.86038 3.70266 7.47025C3.87343 7.14149 4.14149 6.87343 4.47025 6.70266C4.86038 6.5 5.37292 6.5 6.398 6.5H17.602C18.6271 6.5 19.1396 6.5 19.5298 6.70266C19.8585 6.87343 20.1266 7.14149 20.2973 7.47025C20.5 7.86038 20.5 8.37292 20.5 9.398V15.602C20.5 16.6271 20.5 17.1396 20.2973 17.5298C20.1266 17.8585 19.8585 18.1266 19.5298 18.2973C19.1396 18.5 18.6271 18.5 17.602 18.5H6.398C5.37292 18.5 4.86038 18.5 4.47025 18.2973C4.14149 18.1266 3.87343 17.8585 3.70266 17.5298C3.5 17.1396 3.5 16.6271 3.5 15.602V9.398Z" stroke="#000"/>
                                              <path d="M3.5 10.5L20.5 10.5" stroke="#000" stroke-linecap="round"/>
                                              <circle cx="6.5" cy="15.5" r="0.5" fill="#000"/>
                                          </svg>
                                  
                                      </div>
                                      <div>
                                          <h5 class="mb-1 font-weight-bold">{{ $t('common.no_hidden_fees') }}</h5>
                                          <p class="m-0">{{ $t('common.zero_percent_fees') }}</p>
                                      </div>
                                  </div>

                                  <div class="d-flex align-items-center">
                                      <div class="mr-3 icon-box">
                                        <svg style="width: 20px;" xmlns="http://www.w3.org/2000/svg" fill="#000" viewBox="0 0 16 16">
                                              <path d="M7.25 11.2v1.42h1.5V11.2a1.48 1.48 0 0 0 .85-1.32A1.55 1.55 0 0 0 8 8.38a1.55 1.55 0 0 0-1.6 1.5 1.48 1.48 0 0 0 .85 1.32z"/>
                                              <path d="M14.75 5H13.5A5.29 5.29 0 0 0 8 0a5.29 5.29 0 0 0-5.5 5H1.25A1.25 1.25 0 0 0 0 6.25v8.5A1.25 1.25 0 0 0 1.25 16h13.5A1.25 1.25 0 0 0 16 14.75v-8.5A1.25 1.25 0 0 0 14.75 5zM8 1.25A4.05 4.05 0 0 1 12.25 5h-8.5A4.05 4.05 0 0 1 8 1.25zm6.75 13.5H1.25v-8.5h13.5z"/>
                                          </svg>
                                      </div>
                                      <div>
                                          <h5 class="mb-1 font-weight-bold">{{ $t('common.secure_payments') }}</h5>
                                          <p class="m-0">{{ $t('common.your_money_is_protected') }}</p>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div :class="!discount ? 'row' : 'row flex-reverse-row'">
                          <div :class="!discount ? 'col-lg-12' : 'col-xl-12 col-lg-12'">
                            <div class="two-column">
                              <div class="row">
                                <div class="col-xl-8 col-lg-7">
                                  <div class="row">
                                    <div v-if="property.kitchen_available === 1" class="col-md-12">
                                      <div class="about-details row align-items-center">
                                        <div class="col-md-4">
                                          <div class="d-flex align-items-center air-condition pb-3 pb-md-0">
                                              <div class="image mr-3">
                                                  <img :src="propertyOwnerAvatar" alt="image"
                                                    style="border-radius: 50%;height: 45px; width: 45px; object-fit: cover;">
                                                </div>
                                              <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Property_Owner') }}</h5>
                                          </div>
                                        </div>
                                        <div class="col-md-8">
                                          <div> 
                                            <p class="mb-0">{{ property.user.name }}
                                            </p>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                    <div class="col-md-12"><hr /></div>
                                    <div class="col-md-12">
                                      <div class="about-details row  align-items-center">
                                        <div class="col-md-4">
                                           <div class="air-condition pb-3 pb-md-0">
                                            <span><i class="fa fa-home" aria-hidden="true"></i>
                            
                                            </span>
                                            <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Property_Address') }}</h5>
                                          </div>                                          
                                        </div>
                                        <div class="col-md-8">
                                          <p class="mb-0">{{ property.address }}</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12"><hr /></div>
                                    <div class="col-md-12">
                                      <div class="about-details row">
                                        <div class="col-md-4">
                                          <div class="air-condition pb-3 pb-md-0">
                                            <span><i class="fa fa-file-text" aria-hidden="true"></i></span>
                                            <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Description') }}</h5>
                                          </div>
                                          
                                        </div>
                                        <div class="col-md-8">
                                          <p class="mb-0">{{ property.property_description }}</p>
                                          <div v-if="checkIsDemoProperty()" class="demo-property-message font-weight-medium" style="color: red; margin-top: 10px; font-size: 16px;">
                                             {{ $t("common.demo_property_unable_to_book") }}  
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12"><hr /></div>
                                    <div class="col-md-12">
                                      <div class="about-details row">
                                        <div class="col-md-4">
                                            <div class="air-condition pb-3 pb-md-0">
                                              <span><i class="fa fa-clock" aria-hidden="true"></i></span>
                                              <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Range_of_Stay') }}</h5>
                                          </div>
                                         
                                        </div>
                                        <div class="col-md-8">
                                          <div class="range-to-stay">
                                            <p class="mb-2"><img src="../../src/public/assets/images/time.svg" alt="">{{
                                              $t('Propertis.Minimum_Reservation') }} {{
                                                formatMonthDuration(property.min_night_stay) }}</p>
                                            <p><img src="../../src/public/assets/images/time.svg" alt="">{{
                                              $t('Propertis.Maximum_Reservation') }} {{
                                                formatMonthDuration(property.max_night_stay) }}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12"><hr /></div>
                                    <div class="col-md-12">
                                      <div class="about-details row">
                                        <div class="col-md-4">
                                          <div class="air-condition pb-3 pb-md-0">
                                              <span><i class="fa fa-heart" aria-hidden="true"></i></span>
                                               <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Regular_Customers') }}</h5>
                                          </div>
                                        </div>
                                        <div class="col-md-8">
                                          <div class="range-to-stay d-flex flex-wrap gap-30">
                                            <p v-if="property.target_audience.includes('Students')" class="mb-2">
                                              <i class="fas fa-user-graduate"></i>
                                              {{ $t('Propertis.Students') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Temporary Workers')"
                                              class="mb-2">
                                              <i class="fas fa-user"></i>
                                              {{ $t('Propertis.Temporary_Workers') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Digital Nomad')" class="mb-2">
                                              <i class="fas fa-suitcase-rolling"></i>
                                              {{ $t('Propertis.Digital_Nomad') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Expatriate')" class="mb-2">
                                              <i class="fas fa-passport"></i>
                                              {{ $t('Propertis.Expatriate') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Traveler')" class="mb-2">
                                              <i class="fas fa-globe-americas"></i>
                                              {{ $t('Propertis.Traveler') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Freelancer')" class="mb-2">
                                              <i class="fas fa-laptop-code"></i>
                                              {{ $t('Propertis.Freelancer') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Families')" class="mb-2">
                                              <i class="fas fa-users"></i>
                                              {{ $t('Propertis.Families') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Couples')" class="mb-2">
                                              <i class="fas fa-heart"></i>
                                              {{ $t('Propertis.Couples') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Friends')" class="mb-2">
                                              <i class="fas fa-user-friends"></i>
                                              {{ $t('Propertis.Friends') }}
                                            </p>

                                            <p v-if="property.target_audience.includes('Others')" class="mb-2">
                                              <i class="fas fa-ellipsis-h"></i>
                                              {{ $t('Propertis.Others') }}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12"><hr /></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="relative" :class="!discount ? '' : 'col-xl-4 col-lg-5 responsive-col'">
                            <div v-if="discount && (
                              discount.oneweekdisc ||
                              discount.twoweekdisc ||
                              discount.threeweekdisc ||
                              discount.onemonthdis ||
                              discount.twomonthsdis ||
                              discount.threemonthsdis ||
                              discount.fourmonthsdis ||
                              discount.fivemonthsdis ||
                              discount.sixmonthsdis ||
                              discount.sevenmonthsdis ||
                              discount.eightmonthsdis
                            )" class="long_stay_dis discounts-list table-discounts-list">

                              <h4>{{ $t('Propertis.discount_on_long_stays') }}</h4>

                              <div class="long_dis align-items-center" v-if="discount.oneweekdisc">
                                <h5>{{ $t('Propertis.one_week') }} <span class=" ">-{{ discount.oneweekdisc }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.twoweekdisc">
                                <h5>{{ $t('Propertis.two_weeks') }} <span class=" ">-{{ discount.twoweekdisc }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.threeweekdisc">
                                <h5>{{ $t('Propertis.three_weeks') }} <span class=" ">-{{ discount.threeweekdisc
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.onemonthdis">
                                <h5>{{ $t('Propertis.one_month') }} <span class=" ">-{{ discount.onemonthdis }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.twomonthsdis">
                                <h5>{{ $t('Propertis.two_months') }} <span class=" ">-{{ discount.twomonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.threemonthsdis">
                                <h5>{{ $t('Propertis.three_months') }} <span class=" ">-{{ discount.threemonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.fourmonthsdis">
                                <h5>{{ $t('Propertis.four_months') }} <span class=" ">-{{ discount.fourmonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.fivemonthsdis">
                                <h5>{{ $t('Propertis.five_months') }} <span class=" ">-{{ discount.fivemonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.sixmonthsdis">
                                <h5>{{ $t('Propertis.six_months') }} <span class=" ">-{{ discount.sixmonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.sevenmonthsdis">
                                <h5>{{ $t('Propertis.seven_months') }} <span class=" ">-{{ discount.sevenmonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.eightmonthsdis">
                                <h5>{{ $t('Propertis.eight_months') }} <span class=" ">-{{ discount.eightmonthsdis
                                    }}%</span></h5>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                         <div class="col-xl-8 col-lg-7">
                            <div class="two-column" v-if="false">
                              <div class="row align-items-center">
                                <div class="col-md-4">
                                  <div class="heading air-condition pb-3 pb-md-0">
                                    <span><i class="fa fa-star" aria-hidden="true"></i></span>
                                    <h5  class="font-weight-bold mb-0">{{ $t('property_detail.Reviews') }}
                                    </h5>
                                  </div>
                                </div>
                                <div class="col-md-8">
                                  <div class="popular-amenities mb-0">
                                    <ul>
                                      <li>
                                        <div class="stars">
                                          <span class="fa fa-star" :class="{ 'checked': rating >= 1 }"></span>
                                          <span class="fas fa-star" :class="{ 'checked': rating >= 2 }"></span>
                                          <span class="fas fa-star" :class="{ 'checked': rating >= 3 }"></span>
                                          <span class="fas fa-star" :class="{ 'checked': rating >= 4 }"></span>
                                          <span class="fas fa-star" :class="{ 'checked': rating >= 5 }"></span>
                                        </div>
                                      </li>
                                      <li>
                                        <div class="air-condition pb-3 pb-md-0">
                                          <a href="#" @click.prevent="redirectToRating"><span class="review-no font-weight-bold">{{ reviews
                                          }} {{
                                                $t('property_detail.Reviews') }} </span></a>
                                        </div>
                                      </li>
                                      <li>
                                        <div class="air-condition pb-0">
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 p-0" v-if="false"><hr /></div>
                            <div class="two-column">
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="heading air-condition pb-3 pb-md-0">
                                    <span><i class="fa fa-adjust" aria-hidden="true"></i></span>
                                    <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Damage_and_incidentals') }}</h5>
                                  </div>
                                </div>
                                <div class="col-md-8">
                                  <div class="paragrapgh">
                                    <p class="mb-0">{{ $t('Propertis.demage_responsoble') }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 p-0"><hr /></div>
                            <div class="two-column">
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="heading air-condition pb-3 pb-md-0">
                                    <span><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                                    <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Important_information') }}</h5>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <div class="popular-amenities">
                                    <ul></ul>
                                    <div class="paragrapgh">
                                      <p class="font-weight-bold mb-3">
                                        {{ $t('Propertis.house_rules_message') }}
                                      </p>
                                      
                                      <ul style="flex-direction: column; row-gap: 10px;" class="important-information-list">
                                        <li v-if="property.children">
                                          <span>{{ $t('Propertis.Children_are', {
                                            children:
                                              translatePolicy(property.children, 'Children')
                                          })
                                          }}</span>
                                        </li>
                                        <li v-if="property.Events">
                                          <span>{{ $t('Propertis.Events_are', {
                                            events: translatePolicy(property.Events,
                                              'Events')
                                          }) }}</span>
                                        </li>
                                        <li v-if="property.Pets">
                                          <span>{{ $t('Propertis.Pets_are', {
                                            pets: translatePolicy(property.Pets, 'Pets')
                                          }) }}</span>
                                        </li>
                                        <li v-if="property.Smoking">
                                          <span>{{ $t('Propertis.Smoking_is', {
                                            smoking: translatePolicy(property.Smoking,
                                              'Smoking')
                                          })
                                          }}</span>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div class="two-column"
                              v-if="property.user_id !== currentUserId && currentUserId !== null">
                              <div class="row">
                                <div class="col-lg-4">
                                  <div class="heading">
                                    <h2>{{ $t('Propertis.send_message_to_owner') }}</h2>
                                  </div>
                                </div>
                                <div class="col-lg-8">
                                  <div v-if="messageSent">
                                    <p class="text-success">
                                      {{ $t('Propertis.message_sent_to_owner') }}
                                      <span class="text-primary cursor-pointer" @click="messages()">
                                        {{ $t('Propertis.click_here') }}
                                      </span> {{ $t('Propertis.for_further_chat') }}
                                    </p>
                                  </div>
                                  <form v-else @submit.prevent="handleSendMessage" class="send-message">
                                    <div class="form-group">
                                      <textarea class="form-control" id="message" v-model="textForm.message"
                                        :class="{ 'is-invalid': textFormErrors.message }" rows="5"
                                        :placeholder="$t('Propertis.enter_message_placeholder')"
                                        :disabled="isSending"></textarea>
                                      <div class="invalid-feedback">{{ textFormErrors.message }}</div>
                                    </div>

                                    <button type="submit" class="btn btn-primary" :disabled="isSending"
                                      :class="{ disabled: isSending }">{{
                                        $t('Propertis.start_chat') }}</button>
                                  </form>
                                </div>
                              </div>
                            </div>
                        </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab :title="$t('Propertis.Amenities')">
                      <div class="product-detail-sec">
                        <div class="row"> 
                          <div class="details details-section col-lg-8">
                            <h1 class="product-title">{{ $t('property_detail.' + property.property_type) }} {{ $t('property_detail.accommodation_types.' + property.accommodation_type) }} in {{ property.city }}, {{ property.country }}.
                            </h1>
                            <div class="popular-amenities">
                              <h3>{{ $t('Propertis.Amenities') }}</h3>
                              <ul>
                                <li>
                                  <div class="air-condition">
                                    <span><i class="fa fa-bed" aria-hidden="true"></i></span>
                                    <span>{{ property.num_bedrooms }} {{ bedroomLabel }}</span>
                                  </div>
                                </li>
                                <li v-if="property.kitchen_available === 1">
                                  <div class="air-condition">
                                    <span><i class="fas fa-utensils"></i></span>
                                    <span>{{ $t('Propertis.Kitchen') }}</span>
                                  </div>
                                </li>
                                <li v-if="property.tv_available === 1">
                                  <div class="air-condition">
                                    <span><i class="fa fa-tv" aria-hidden="true"></i></span>
                                    <span>{{ $t('Propertis.TV') }}</span>
                                  </div>
                                </li>
                                <li v-if="property.wifi_available === 1">
                                  <div class="air-condition">
                                    <span><i class="fa fa-wifi" aria-hidden="true"></i></span>
                                    <span>{{ $t('Propertis.Wifi') }}</span>
                                  </div>
                                </li>
                                <li>
                                  <div class="air-condition">
                                    <span><i class="fa fa-bath" aria-hidden="true"></i></span>
                                    <span>{{ property.num_bathrooms }} {{ bathroomLabel }}</span>
                                  </div>
                                </li>
                              </ul>
                              <b-button type="button" class="see-all-btn" v-b-modal.modal-scrollable>
                                <span aria-hidden="true">{{ $t('Propertis.See_all') }}</span>
                                <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </b-button>
                            </div>

                          </div>
                          <div class="col-lg-4 relative">
                            <div class="pricing-detail-box flex-pricing-detail-box mb-5 mb-lg-0">
                              <!-- Discounted Price Display -->
                              <div v-if="pfDisprice" class="strikethrough">
                                <h2 style="margin-bottom: -15px;">
                                  {{ currency }} {{ totaldicPrice1 === 0 ? pfDisprice : totaldicPrice1 }}
                                </h2>
                                <!-- Discount Percentage Badge -->
                                <div v-if="property.discountpersentage != null" class="favorite-button-discount">
                                  <span class="checked-span">-{{ property.discountpersentage }}%</span>
                                </div>
                              </div>
                              <br>

                              <!-- Regular Price Display -->
                              <div class="heading">
                                <!-- Loading State -->
                                <span v-if="loading">
                                  <img :src="loaderGif" :alt="$t('common.loading')" class="loading-gif" />
                                </span>

                                <!-- Price Display -->
                                <template v-else>
                                  <h2 class="font-weight-bold">
                                    {{ currency }}
                                    {{ getDisplayPrice }}/<span class="text-xlightgrey font-weight-normal">{{ getPricePeriod }}</span>
                                  </h2>
                                </template>
                              </div>
                              <div class="date-pricing">
                                <svg
                                  class="uitk-icon uitk-spacing uitk-spacing-margin-inlineend-two uitk-icon-small uitk-icon-negative-theme"
                                  aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <path
                                    d="M12 17.042a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-3.396a.75.75 0 0 0 .75-.75V7.783a.75.75 0 1 0-1.5 0v5.113c0 .415.336.75.75.75z">
                                  </path>
                                  <path
                                    d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18.5c-4.687 0-8.5-3.813-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5z">
                                  </path>
                                </svg>
                                <span class="font-weight-bold">{{ $t('Propertis.Full_refund') }}</span>
                              </div>
                              <form action="#" class="payment-form for-custom-style">
                                <div class="">
                                  <div class="form-field">
                                    <div class="date-picker" style="display: none;">
                                      <date-range-picker v-model="dateRange" :format="format" :placeholder="placeholder"
                                        :date-format="dateFormat" :ranges='false' :locale-data="locale_data"
                                        :key="localeKey" :min-date="today" />
                                    </div>
                                  </div>
                                  <div class="form-field">
                                    <div class="date-picker date-field-selection">
                                      <date-range-picker v-model="dateRange" :min-date="today" :format="format"
                                        :placeholder="placeholder" :date-format="dateFormat" :ranges='false'
                                        :locale-data="locale_data" :key="localeKey" />

                                    </div>
                                  </div>
                                  <div class="accordian-guests">
                                    <div class="form-field" ref="toggle3" @click="togglePopup3">
                                      <p class="form-control" style="padding: 12px 14px; border-radius: 10px;">
                                        {{ property.max_guests }} {{ property.max_guests === 1 ? $t('Propertis.Guest') :
                                          $t('Propertis.Guests') }}
                                      </p>
                                    </div>
                                    <div class="popup-guest" v-if="isPopupVisible3" ref="popup3">
                                      <div class="guest-content">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="decrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="1.00" v-model="property.max_guests"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="increment">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="childDecrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="0.00" :value="childQuantity"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="childIncrement">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="petDecrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="0.00" :value="petQuantity"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="petIncrement">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-btn mt-3">
                                  <button class="availbility-btn" type="button" @click="redirectToPayment"
                                    :disabled="loading">{{
                                      $t('property_detail.request_button') }}</button>
                                  <!-- <button v-if="!hasMadeOffer" class="availbility-btn mt-2" type="button"
                                    @click="sharedViewModal">
                                    {{ $t('Propertis.make_custom_offer') }}
                                  </button> -->
                                  <button v-if="hasMadeOffer" class="availbility-btn mt-2" type="button"
                                    @click="viewMyOffers">
                                    {{ $t('Propertis.my_offers') }}
                                  </button>
                                </div>

                                <div>
                                  <b-modal id="shared-modal" centered ref="shared-modal" scrollable
                                    :title="computedTitle" size="lg" :hide-footer="true">
                                    <div class="body-content shared-form-fields px-1 px-md-4 py-1">
                                      <form @submit.prevent="submitOffer" class="for-custom-style">
                                        <div class="mb-3" style="float: right;">
                                          <p>{{ $t('Propertis.make_offer_info') }}</p>
                                        </div>

                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="">{{ $t('Propertis.number_of_guests') }}</label>
                                          </div>
                                          <div>
                                            <div class="accordian-guests">
                                              <div class="form-field" ref="toggle2" @click="togglePopup2">
                                                <p class="form-control" style="border-radius: 10px;">
                                                  {{ property.max_guests }} {{ property.max_guests === 1 ?
                                                    $t('Propertis.Guest') :
                                                    $t('Propertis.Guests') }}
                                                </p>
                                              </div>
                                              <div class="popup-guest" v-if="isPopupVisible2" ref="popup2">
                                                <div class="guest-content">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="decrement">-</b-btn>
                                                          </b-input-group-prepend>
                                                          <b-form-input type="number" min="1.00"
                                                            v-model="property.max_guests" readonly></b-form-input>
                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="increment">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                                <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="childDecrement">-</b-btn>
                                                          </b-input-group-prepend>
                                                          <b-form-input type="number" min="0.00" :value="childQuantity"
                                                            readonly></b-form-input>
                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="childIncrement">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                                <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="petDecrement">-</b-btn>
                                                          </b-input-group-prepend>
                                                          <b-form-input type="number" min="0.00" :value="petQuantity"
                                                            readonly></b-form-input>
                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="petIncrement">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="">{{ $t('Propertis.stay_duration') }}</label>
                                          </div>
                                          <div class="date-picker">
                                            <date-range-picker v-model="dateRange" :min-date="today" :format="format"
                                              :placeholder="placeholder" :date-format="dateFormat" :ranges="false"
                                              :locale-data="locale_data" :key="localeKey" class="mb-0" />
                                          </div>
                                        </div>

                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="">{{ $t('Propertis.original_calculated_price') }}</label>
                                          </div>
                                          <input v-if="totalPrice1" type="text" name="" id=""
                                            :value="currency + ' ' + totalPrice1" disabled>
                                          <input v-else type="text" name="" id=""
                                            :value="currency + ' ' + pfprice + '/' + $t('property_detail.night').toLowerCase()"
                                            disabled>
                                        </div>

                                        <div class="form-group mb-4">
                                          <div class="mb-2">
                                            <label for="offerPrice">{{ $t('Propertis.offer_your_price') }}<span
                                                style="color: red;">*</span></label>
                                          </div>
                                          <div class="remove-border">
                                            <input type="number" name="offerPrice" id="offerPrice"
                                              v-model.number="offeredPrice" @input="validateOfferPrice"
                                              :disabled="totalPrice1 <= 0"
                                              :placeholder="totalPrice1 <= 0 ? $t('Propertis.select_dates_first') : $t('Propertis.enter_your_offer')" />
                                            <div v-if="offerPriceError && offerPriceError.length"
                                              class="invalid-feedback offerPriceError">
                                              <div v-for="error in offerPriceError" :key="error">{{ error }}</div>
                                            </div>
                                            <!-- Better error display -->
                                            <div v-if="offerPriceError && offerPriceError.length"
                                              class="text-danger mt-2">
                                              <small v-for="error in offerPriceError" :key="error">{{ error }}</small>
                                            </div>

                                            <!-- Friendly hint when no dates selected -->
                                            <div v-else-if="totalPrice1 <= 0" class="text-muted mt-2">
                                              <small>{{ $t('Propertis.select_dates_to_see_price') }}</small>
                                            </div>
                                          </div>
                                        </div>

                                        <p class="description mb-5">
                                          {{ $t('Propertis.offers_cannot_be_less_than', { percentage: 30 }) }}
                                        </p>

                                        <div class="footer-bottom form-btn">
                                          <button class="availbility-btn mt-2 card-blue-btn p-3" type="submit">
                                            <span v-if="isLoading">{{ $t('Propertis.submitting') }}</span>
                                            <span v-else>{{ $t('Propertis.submit') }}</span>
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                  </b-modal>
                                </div>

                                <!-- -------------------------- -->
                                <div>
                                  <b-modal id="my-offers-modal" class="offer-new-modal" centered ref="my-offers-modal"
                                    scrollable :title="$t('offers.my_offers')" size="lg" :hide-footer="true">
                                    <!-- Tabs Section -->
                                    <b-tabs v-model="activeTab" class="my-offer-tabs">
                                      <!-- My Offers Tab -->
                                      <b-tab :title="$t('offers.my_offers')" active>
                                        <div class="offer-detail-modal-table">
                                          <div class="card">
                                            <div class="card-header">
                                              <h4 class="card-title m-0">{{ $t('offers.made_today') }}</h4>
                                              <h5 class="card-title m-0" style="float: right;">
                                                {{ $t('offers.remaining_attempts') }}: {{ remainingAttempts }}
                                              </h5>
                                            </div>
                                            <div class="card-body">
                                              <div v-if="showMakeAnotherOffer" class="text-center mb-3">
                                                <button class="make-another-offer-btn" @click="makeAnotherOffer">
                                                  {{ $t('offers.make_another_offer') }}
                                                </button>
                                              </div>
                                              <div class="table-responsive">
                                                <table class="table">
                                                  <thead>
                                                    <tr>
                                                      <th>{{ $t('offers.offer_id') }}</th>
                                                      <th>{{ $t('offers.customer_name') }}</th>
                                                      <th>{{ $t('offers.property_type') }}</th>
                                                      <th>
                                                        {{ $t('offers.total_price') }}
                                                        <span class="tooltip-container ml-1">
                                                          <span class="info-icon">ℹ️</span>
                                                          <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                          }}</span>
                                                        </span>
                                                      </th>
                                                      <th>{{ $t('offers.offered_price') }}</th>
                                                      <th>{{ $t('offers.price_difference_pct') }}</th>
                                                      <th>{{ $t('offers.offer_status') }}</th>
                                                      <th>{{ $t('Propertis.start_date') }}</th>
                                                      <th>{{ $t('Propertis.end_date') }}</th>
                                                      <th>{{ $t('offers.action') }}</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr v-for="offer in offersData" :key="offer.id">
                                                      <td>{{ offer.offer_id }}</td>
                                                      <td>{{ offer.user.name }}</td>
                                                      <td>{{ offer.property.property_type }}</td>
                                                      <td>{{ offer.currency }} {{ offer.original_price }}</td>
                                                      <td>{{ offer.currency }} {{ offer.offered_price }}</td>
                                                      <td>{{ offer.price_difference_percentage }}%</td>
                                                      <td>{{ translateOfferStatusTable(offer.status) }}</td>
                                                      <td>{{ formatDate(offer.start_date) }}</td>
                                                      <td>{{ formatDate(offer.end_date) }}</td>
                                                      <td>
                                                        <button v-if="offer.status === 'accepted' && !offer.is_booked"
                                                          class="btn btn-primary" @click="bookNow(offer)">
                                                          {{ $t('offers.book_now') }}
                                                        </button>
                                                        <span v-else>
                                                          {{ offer.is_booked ? $t('offers.booked') :
                                                            translateOfferStatusTable(offer.status) }}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    <tr v-if="!offersData.length">
                                                      <td colspan="8">{{ $t('offers.none_today') }}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </b-tab>

                                      <!-- Previous Offers Tab -->
                                      <b-tab :title="$t('offers.previous_offers')">
                                        <div class="offer-detail-modal-table">
                                          <div class="card">
                                            <div class="card-header">
                                              <h4 class="card-title m-0">{{ $t('offers.previous_offers') }}</h4>
                                            </div>
                                            <div class="card-body">
                                              <div class="table-responsive">
                                                <table class="table">
                                                  <thead>
                                                    <tr>
                                                      <th>{{ $t('offers.offer_id') }}</th>
                                                      <th>{{ $t('offers.customer_name') }}</th>
                                                      <th>{{ $t('offers.property_type') }}</th>
                                                      <th>
                                                        {{ $t('offers.total_price') }}
                                                        <span class="tooltip-container ml-1">
                                                          <span class="info-icon">ℹ️</span>
                                                          <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                          }}</span>
                                                        </span>
                                                      </th>
                                                      <th>{{ $t('offers.offered_price') }}</th>
                                                      <th>{{ $t('offers.price_difference_pct') }}</th>
                                                      <th>{{ $t('offers.offer_status') }}</th>
                                                      <th>{{ $t('Propertis.start_date') }}</th>
                                                      <th>{{ $t('Propertis.end_date') }}</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr v-for="offer in previousOffersData" :key="offer.id">
                                                      <td>{{ offer.offer_id }}</td>
                                                      <td>{{ offer.user.name }}</td>
                                                      <td>{{ offer.property.property_type }}</td>
                                                      <td>{{ offer.currency }} {{ offer.original_price }}</td>
                                                      <td>{{ offer.currency }} {{ offer.offered_price }}</td>
                                                      <td>{{ offer.price_difference_percentage }}%</td>
                                                      <td>{{ translateOfferStatusTable(offer.status) }}</td>
                                                      <td>{{ formatDate(offer.start_date) }}</td>
                                                      <td>{{ formatDate(offer.end_date) }}</td>
                                                    </tr>
                                                    <tr v-if="!previousOffersData.length">
                                                      <td colspan="6">{{ $t('offers.none_previous') }}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                              <b-pagination v-if="totalPreviousOffers > perPage"
                                                :total-rows="totalPreviousOffers" :per-page="perPage"
                                                v-model="currentPage" @change="onPageChange"></b-pagination>
                                            </div>
                                          </div>
                                        </div>
                                      </b-tab>

                                    </b-tabs>
                                  </b-modal>
                                </div>
                              </form>

                              <div v-if="longdis">
                                <div class="timer favorite-button-discount">
                                  <span class="checked-span">-{{ longdis }}%</span>
                                </div>
                              </div>

                              <div v-else-if="pfDisprice && showTimer">
                                <div class="timer">
                                  <span>{{ $t('Propertis.offer_ends_in') }}</span> <span>{{ formattedTime }}</span>
                                </div>
                              </div>

                              <div v-else-if="flashDiscount && showTimer">
                                <div class="timer">
                                  <span>{{ $t('Propertis.offer_ends_in') }}</span> <span>{{ formattedTime }}</span>
                                </div>
                              </div>
                                <div class="detail-sidebar-icons-boxes py-4">
                                <div class="d-flex align-items-center mb-4">
                                  <div class="mr-3 icon-box">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                          <path d="M9.5 12.4L10.9286 14L14.5 10" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 14.4963 20.1632 16.4284 19 17.9041M3.19284 14C4.05026 18.2984 7.57641 20.5129 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C14.6796 21.2747 15.3324 20.9478 16 20.5328" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                  </div>
                                  <div>
                                     <h5 class="mb-1 font-weight-bold">Verified Listings</h5>
                                     <p class="m-0">All properties are checked</p>
                                  </div>
                                 </div>

                                 <div class="d-flex align-items-center mb-4">
                                      <div class="mr-3 icon-box">
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                              <path d="M3.5 9.398C3.5 8.37292 3.5 7.86038 3.70266 7.47025C3.87343 7.14149 4.14149 6.87343 4.47025 6.70266C4.86038 6.5 5.37292 6.5 6.398 6.5H17.602C18.6271 6.5 19.1396 6.5 19.5298 6.70266C19.8585 6.87343 20.1266 7.14149 20.2973 7.47025C20.5 7.86038 20.5 8.37292 20.5 9.398V15.602C20.5 16.6271 20.5 17.1396 20.2973 17.5298C20.1266 17.8585 19.8585 18.1266 19.5298 18.2973C19.1396 18.5 18.6271 18.5 17.602 18.5H6.398C5.37292 18.5 4.86038 18.5 4.47025 18.2973C4.14149 18.1266 3.87343 17.8585 3.70266 17.5298C3.5 17.1396 3.5 16.6271 3.5 15.602V9.398Z" stroke="#000"/>
                                              <path d="M3.5 10.5L20.5 10.5" stroke="#000" stroke-linecap="round"/>
                                              <circle cx="6.5" cy="15.5" r="0.5" fill="#000"/>
                                          </svg>
                                  
                                      </div>
                                      <div>
                                          <h5 class="mb-1 font-weight-bold">No Hidden Fees</h5>
                                          <p class="m-0">Zero hidden charges</p>
                                      </div>
                                  </div>

                                  <div class="d-flex align-items-center">
                                      <div class="mr-3 icon-box">
                                        <svg style="width: 20px;" xmlns="http://www.w3.org/2000/svg" fill="#000" viewBox="0 0 16 16">
                                              <path d="M7.25 11.2v1.42h1.5V11.2a1.48 1.48 0 0 0 .85-1.32A1.55 1.55 0 0 0 8 8.38a1.55 1.55 0 0 0-1.6 1.5 1.48 1.48 0 0 0 .85 1.32z"/>
                                              <path d="M14.75 5H13.5A5.29 5.29 0 0 0 8 0a5.29 5.29 0 0 0-5.5 5H1.25A1.25 1.25 0 0 0 0 6.25v8.5A1.25 1.25 0 0 0 1.25 16h13.5A1.25 1.25 0 0 0 16 14.75v-8.5A1.25 1.25 0 0 0 14.75 5zM8 1.25A4.05 4.05 0 0 1 12.25 5h-8.5A4.05 4.05 0 0 1 8 1.25zm6.75 13.5H1.25v-8.5h13.5z"/>
                                          </svg>
                                      </div>
                                      <div>
                                          <h5 class="mb-1 font-weight-bold">Secure Payments</h5>
                                          <p class="m-0">Your money is protected</p>
                                      </div>
                                  </div>


                              </div>
                            </div>
                            <div v-if="discount && (
                              discount.oneweekdisc ||
                              discount.twoweekdisc ||
                              discount.threeweekdisc ||
                              discount.onemonthdis ||
                              discount.twomonthsdis ||
                              discount.threemonthsdis ||
                              discount.fourmonthsdis ||
                              discount.fivemonthsdis ||
                              discount.sixmonthsdis ||
                              discount.sevenmonthsdis ||
                              discount.eightmonthsdis
                            )" class="long_stay_dis discounts-list table-discounts-list">

                              <h4>{{ $t('Propertis.discount_on_long_stays') }}</h4>

                              <div class="long_dis align-items-center" v-if="discount.oneweekdisc">
                                <h5>{{ $t('Propertis.one_week') }} <span class=" ">-{{ discount.oneweekdisc }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.twoweekdisc">
                                <h5>{{ $t('Propertis.two_weeks') }} <span class=" ">-{{ discount.twoweekdisc }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.threeweekdisc">
                                <h5>{{ $t('Propertis.three_weeks') }} <span class=" ">-{{ discount.threeweekdisc
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.onemonthdis">
                                <h5>{{ $t('Propertis.one_month') }} <span class=" ">-{{ discount.onemonthdis }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.twomonthsdis">
                                <h5>{{ $t('Propertis.two_months') }} <span class=" ">-{{ discount.twomonthsdis
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.threemonthsdis">
                                <h5>{{ $t('Propertis.three_months') }} <span class=" ">-{{ discount.threemonthsdis
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.fourmonthsdis">
                                <h5>{{ $t('Propertis.four_months') }} <span class=" ">-{{ discount.fourmonthsdis
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.fivemonthsdis">
                                <h5>{{ $t('Propertis.five_months') }} <span class=" ">-{{ discount.fivemonthsdis
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.sixmonthsdis">
                                <h5>{{ $t('Propertis.six_months') }} <span class=" ">-{{ discount.sixmonthsdis
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.sevenmonthsdis">
                                <h5>{{ $t('Propertis.seven_months') }} <span class=" ">-{{ discount.sevenmonthsdis
                                }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.eightmonthsdis">
                                <h5>{{ $t('Propertis.eight_months') }} <span class=" ">-{{ discount.eightmonthsdis
                                }}%</span></h5>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab :title="$t('Propertis.Location')">
                      <div class="product-detail-sec">
                        <div class="row">
                          <div class="details details-section col-lg-8">

                            <div class="explore-area">
                              <h3 class="font-weight-bold mb-3">{{ $t('Propertis.explore') }}</h3>
                              <div class="row">
                                <div class="col-lg-12">
                                  <div class="map-sec" ref="exploreMap" style="height: 200px;"></div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-4 relative">

                            <div class="pricing-detail-box flex-pricing-detail-box mb-5 mb-lg-0">
                              <!-- Discounted Price Display -->
                              <div v-if="pfDisprice" class="strikethrough">
                                <h2 style="margin-bottom: -15px;">
                                  {{ currency }} {{ totaldicPrice1 === 0 ? pfDisprice : totaldicPrice1 }}
                                </h2>
                                <!-- Discount Percentage Badge -->
                                <div v-if="property.discountpersentage != null" class="favorite-button-discount">
                                  <span class="checked-span">-{{ property.discountpersentage }}%</span>
                                </div>
                              </div>
                              <br>

                              <!-- Regular Price Display -->
                              <div class="heading">
                                <!-- Loading State -->
                                <span v-if="loading">
                                  <img :src="loaderGif" alt="Loading..." class="loading-gif" />
                                </span>

                                <!-- Price Display -->
                                <template v-else>
                                  <h2 class="font-weight-bold">
                                    {{ currency }}
                                    {{ getDisplayPrice }}/<span class="text-xlightgrey font-weight-normal">{{ getPricePeriod }}</span>
                                  </h2>
                                </template>
                              </div>
                              <div class="date-pricing">
                                <svg
                                  class="uitk-icon uitk-spacing uitk-spacing-margin-inlineend-two uitk-icon-small uitk-icon-negative-theme"
                                  aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink">
                                  <path
                                    d="M12 17.042a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-3.396a.75.75 0 0 0 .75-.75V7.783a.75.75 0 1 0-1.5 0v5.113c0 .415.336.75.75.75z">
                                  </path>
                                  <path
                                    d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18.5c-4.687 0-8.5-3.813-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5 4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5z">
                                  </path>
                                </svg>
                                <span class="font-weight-bold">{{ $t('Propertis.Full_refund') }}</span>
                              </div>
                              <form action="#" class="payment-form for-custom-style">
                                <div class="">
                                  <div class="form-field">
                                    <div class="date-picker" style="display: none;">
                                      <date-range-picker v-model="dateRange" :format="format" :placeholder="placeholder"
                                        :date-format="dateFormat" :ranges='false' :locale-data="locale_data"
                                        :key="localeKey" :min-date="today" />

                                    </div>
                                  </div>
                                  <div class="form-field">
                                    <div class="date-picker  date-field-selection">
                                      <date-range-picker v-model="dateRange" :min-date="today" :format="format"
                                        :placeholder="placeholder" :date-format="dateFormat" :ranges='false'
                                        :locale-data="locale_data" :key="localeKey" />

                                    </div>
                                  </div>
                                  <div class="accordian-guests">
                                    <div class="form-field" ref="toggle1" @click="togglePopup1">
                                      <p class="form-control" style="padding: 12px 14px; border-radius: 10px;">
                                        {{ property.max_guests }} {{ property.max_guests === 1 ? $t('Propertis.Guest') :
                                          $t('Propertis.Guests') }}
                                      </p>
                                    </div>
                                    <div class="popup-guest" v-if="isPopupVisible1" ref="popup1">
                                      <div class="guest-content">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="decrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="1.00" v-model="property.max_guests"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="increment">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="childDecrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="0.00" :value="childQuantity"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="childIncrement">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                      <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                                        <div class="guest-col">
                                          <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                                        </div>
                                        <div class="guest-col">
                                          <template>
                                            <div class="quantity">
                                              <b-input-group>
                                                <b-input-group-prepend>
                                                  <b-btn variant="info" @click="petDecrement">-</b-btn>
                                                </b-input-group-prepend>

                                                <b-form-input type="number" min="0.00" :value="petQuantity"
                                                  readonly></b-form-input>

                                                <b-input-group-append>
                                                  <b-btn variant="info" @click="petIncrement">+</b-btn>
                                                </b-input-group-append>
                                              </b-input-group>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-btn mt-3">
                                  <button class="availbility-btn" type="button" @click="redirectToPayment"
                                    :disabled="loading">{{
                                      $t('property_detail.request_button') }}</button>
                                  <!-- <button v-if="!hasMadeOffer" class="availbility-btn mt-2" type="button"
                                    @click="sharedViewModal">
                                    {{ $t('Propertis.make_custom_offer') }}
                                  </button> -->
                                  <button v-if="hasMadeOffer" class="availbility-btn mt-2" type="button"
                                    @click="viewMyOffers">
                                    {{ $t('Propertis.my_offers') }}
                                  </button>
                                </div>

                                <div>
                                  <b-modal id="shared-modal" centered ref="shared-modal" scrollable
                                    :title="computedTitle" size="lg" :hide-footer="true">
                                    <div class="body-content shared-form-fields px-1 px-md-3 py-1">
                                      <form @submit.prevent="submitOffer" class="for-custom-style">
                                        <div class="mb-3" style="float: right;">
                                          <p>{{ $t('property_detail.offers_message', { attempts: remainingAttempts }) }}
                                          </p>

                                        </div>

                                        <div class="form-group mb-3">
                                          <div class="mb-2">
                                            <label for="">{{ $t('offers.number_of_guests') }}</label>
                                          </div>
                                          <div>
                                            <div class="accordian-guests">
                                              <div class="form-field" ref="toggle" @click="togglePopup">
                                                <p class="form-control" style="border-radius: 10px;">
                                                  {{ property.max_guests }} {{ property.max_guests === 1 ?
                                                    $t('Propertis.Guest') :
                                                    $t('Propertis.Guests') }}
                                                </p>
                                              </div>
                                              <div class="popup-guest" v-if="isPopupVisible" ref="popup">
                                                <div class="guest-content">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="decrement">-</b-btn>
                                                          </b-input-group-prepend>

                                                          <b-form-input type="number" min="1.00"
                                                            v-model="property.max_guests" readonly></b-form-input>

                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="increment">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                                <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="childDecrement">-</b-btn>
                                                          </b-input-group-prepend>

                                                          <b-form-input type="number" min="0.00" :value="childQuantity"
                                                            readonly></b-form-input>

                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="childIncrement">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                                <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                                                  <div class="guest-col">
                                                    <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                                                  </div>
                                                  <div class="guest-col">
                                                    <template>
                                                      <div class="quantity">
                                                        <b-input-group>
                                                          <b-input-group-prepend>
                                                            <b-btn variant="info" @click="petDecrement">-</b-btn>
                                                          </b-input-group-prepend>

                                                          <b-form-input type="number" min="0.00" :value="petQuantity"
                                                            readonly></b-form-input>

                                                          <b-input-group-append>
                                                            <b-btn variant="info" @click="petIncrement">+</b-btn>
                                                          </b-input-group-append>
                                                        </b-input-group>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="form-group mb-3">
                                          <div class="mb-2">
                                            <label for="">{{ $t('Propertis.stay_duration') }}</label>
                                          </div>
                                          <div class="date-picker">
                                            <date-range-picker v-model="dateRange" :min-date="today" :format="format"
                                              :placeholder="$t('Propertis.stay_duration_placeholder')"
                                              :date-format="dateFormat" :ranges="false" :locale-data="locale_data"
                                              :key="localeKey" class="mb-0" />
                                          </div>
                                        </div>

                                        <div class="form-group mb-3">
                                          <div class="mb-2">
                                            <label for="">{{ $t('Propertis.original_calculated_price') }}</label>
                                          </div>
                                          <input v-if="totalPrice1" type="text" name="" id=""
                                            :value="currency + ' ' + totalPrice1" disabled>
                                          <input v-else type="text" name="" id=""
                                            :value="currency + ' ' + pfprice + '/' + $t('property_detail.night').toLowerCase()"
                                            disabled>
                                        </div>

                                        <div class="form-group mb-3">
                                          <div class="mb-2">
                                            <label for="offerPrice">{{ $t('Propertis.offer_your_price') }} <span
                                                style="color: red;">*</span></label>
                                          </div>
                                          <div class="remove-border">
                                            <input type="number" name="offerPrice" id="offerPrice"
                                              v-model.number="offeredPrice" @input="validateOfferPrice"
                                              :disabled="totalPrice1 <= 0"
                                              :placeholder="totalPrice1 <= 0 ? $t('Propertis.select_dates_first') : $t('Propertis.enter_your_offer')" />
                                            <div v-if="offerPriceError && offerPriceError.length"
                                              class="invalid-feedback offerPriceError">
                                              <div v-for="error in offerPriceError" :key="error">{{ error }}</div>
                                            </div>
                                            <!-- Better error display -->
                                            <div v-if="offerPriceError && offerPriceError.length"
                                              class="text-danger mt-2">
                                              <small v-for="error in offerPriceError" :key="error">{{ error }}</small>
                                            </div>

                                            <!-- Friendly hint when no dates selected -->
                                            <div v-else-if="totalPrice1 <= 0" class="text-muted mt-2">
                                              <small>{{ $t('Propertis.select_dates_to_see_price') }}</small>
                                            </div>
                                          </div>
                                        </div>

                                        <p class="description mb-4">
                                          {{ $t('Propertis.offers_cannot_be_less_than', { percentage: 30 }) }}
                                        </p>

                                        <div class="footer-bottom form-btn">
                                          <button class="availbility-btn mt-2 card-blue-btn p-3" :disabled="isLoading"
                                            type="submit">
                                            <span v-if="isLoading">{{ $t('Propertis.submitting') }}</span>
                                            <span v-else>{{ $t('Propertis.submit') }}</span>
                                          </button>
                                        </div>

                                      </form>
                                    </div>
                                  </b-modal>
                                </div>
                                <!-- -------------------------- -->
                                <div>
                                  <b-modal id="my-offers-modal" class="offer-new-modal" centered ref="my-offers-modal"
                                    scrollable :title="$t('Propertis.My_Offers')" size="xl" :hide-footer="true">

                                    <!-- Tabs Section -->
                                    <b-tabs v-model="activeTab" class="my-offer-tabs">

                                      <!-- My Offers Tab -->
                                      <b-tab :title="$t('Propertis.My_Offers')" active>
                                        <div class="offer-detail-modal-table">
                                          <div class="card">
                                            <div class="card-header">
                                              <h4 class="card-title m-0">{{ $t('offers.made_today') }}</h4>
                                              <h5 class="card-title m-0" style="float: right;">
                                                {{ $t('offers.remaining_attempts') }}: {{ remainingAttempts }}
                                              </h5>
                                            </div>
                                            <div class="card-body">
                                              <div v-if="showMakeAnotherOffer" class="text-center mb-3">
                                                <button class="make-another-offer-btn" @click="makeAnotherOffer">
                                                  {{ $t('offers.make_another_offer') }}
                                                </button>
                                              </div>
                                              <div class="table-responsive">
                                                <table class="table">
                                                  <thead>
                                                    <tr>
                                                      <th>{{ $t('offers.offer_id') }}</th>
                                                      <th>{{ $t('offers.customer_name') }}</th>
                                                      <th>{{ $t('offers.property_type') }}</th>
                                                      <th>
                                                        {{ $t('offers.total_price') }}
                                                        <span class="tooltip-container ml-1">
                                                          <span class="info-icon">ℹ️</span>
                                                          <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                          }}</span>
                                                        </span>
                                                      </th>
                                                      <th>{{ $t('offers.offered_price') }}</th>
                                                      <th>{{ $t('offers.price_difference_pct') }}</th>
                                                      <th>{{ $t('offers.offer_status') }}</th>
                                                      <th>{{ $t('Propertis.start_date') }}</th>
                                                      <th>{{ $t('Propertis.end_date') }}</th>
                                                      <th>{{ $t('offers.action') }}</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr v-for="offer in offersData" :key="offer.id">
                                                      <td>{{ offer.offer_id }}</td>
                                                      <td>{{ offer.user.name }}</td>
                                                      <td>{{ offer.property.property_type }}</td>
                                                      <td>{{ offer.currency }} {{ offer.original_price }}</td>
                                                      <td>{{ offer.currency }} {{ offer.offered_price }}</td>
                                                      <td>{{ offer.price_difference_percentage }}%</td>
                                                      <td>{{ translateOfferStatusTable(offer.status) }}</td>
                                                      <td>{{ formatDate(offer.start_date) }}</td>
                                                      <td>{{ formatDate(offer.end_date) }}</td>
                                                      <td>
                                                        <button v-if="offer.status === 'accepted' && !offer.is_booked"
                                                          class="btn btn-primary" @click="bookNow(offer)">
                                                          {{ $t('offers.book_now') }}
                                                        </button>
                                                        <span v-else>
                                                          {{ offer.is_booked ? $t('offers.booked') :
                                                            translateOfferStatusTable(offer.status) }}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    <tr v-if="!offersData.length">
                                                      <td colspan="8">{{ $t('offers.none_today') }}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </b-tab>
                                      <!-- Previous Offers Tab -->
                                      <b-tab :title="$t('offers.previous_offers')">
                                        <div class="offer-detail-modal-table">
                                          <div class="card">
                                            <div class="card-header">
                                              <h4 class="card-title m-0">{{ $t('offers.previous_offers') }}</h4>
                                            </div>
                                            <div class="card-body">
                                              <div class="table-responsive">
                                                <table class="table">
                                                  <thead>
                                                    <tr>
                                                      <th>{{ $t('offers.offer_id') }}</th>
                                                      <th>{{ $t('offers.customer_name') }}</th>
                                                      <th>{{ $t('offers.property_type') }}</th>
                                                      <th>
                                                        {{ $t('offers.total_price') }}
                                                        <span class="tooltip-container ml-1">
                                                          <span class="info-icon">ℹ️</span>
                                                          <span class="tooltip-text">{{ $t('offers.total_price_hint')
                                                          }}</span>
                                                        </span>
                                                      </th>
                                                      <th>{{ $t('offers.offered_price') }}</th>
                                                      <th>{{ $t('offers.price_difference_pct') }}</th>
                                                      <th>{{ $t('offers.offer_status') }}</th>
                                                      <th>{{ $t('Propertis.start_date') }}</th>
                                                      <th>{{ $t('Propertis.end_date') }}</th>
                                                      <th>{{ $t('offers.action') }}</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    <tr v-for="offer in previousOffersData" :key="offer.id">
                                                      <td>{{ offer.offer_id }}</td>
                                                      <td>{{ offer.user.name }}</td>
                                                      <td>{{ offer.property.property_type }}</td>
                                                      <td>{{ offer.currency }} {{ offer.original_price }}</td>
                                                      <td>{{ offer.currency }} {{ offer.offered_price }}</td>
                                                      <td>{{ offer.price_difference_percentage }}%</td>
                                                      <td>{{ translateOfferStatusTable(offer.status) }}</td>
                                                      <td>{{ formatDate(offer.start_date) }}</td>
                                                      <td>{{ formatDate(offer.end_date) }}</td>
                                                      <td>
                                                        <button v-if="offer.status === 'accepted' && !offer.is_booked"
                                                          class="btn btn-primary" @click="bookNow(offer)">
                                                          {{ $t('offers.book_now') }}
                                                        </button>
                                                        <span v-else>
                                                          {{ offer.is_booked ? $t('offers.booked') :
                                                            translateOfferStatusTable(offer.status) }}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                    <tr v-if="!previousOffersData.length">
                                                      <td colspan="6">{{ $t('offers.none_previous') }}</td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                              <b-pagination v-if="totalPreviousOffers > perPage"
                                                :total-rows="totalPreviousOffers" :per-page="perPage"
                                                v-model="currentPage" @change="onPageChange"></b-pagination>
                                            </div>
                                          </div>
                                        </div>
                                      </b-tab>
                                    </b-tabs>
                                  </b-modal>
                                </div>
                              </form>
                              <div v-if="longdis">
                                <div class="timer favorite-button-discount"><span class="checked-span">-{{ longdis
                                }}%</span>
                                </div>
                              </div>
                              <div v-else-if="pfDisprice && showTimer">
                                <div class="timer">
                                  <span>{{ $t('Propertis.offer_ends_in') }}</span> <span>{{ formattedTime }}</span>
                                </div>
                              </div>
                              <div v-else-if="flashDiscount && showTimer">
                                <div class="timer">
                                  <span>{{ $t('Propertis.offer_ends_in') }}</span> <span>{{ formattedTime }}</span>
                                </div>
                              </div>
                                 <div class="detail-sidebar-icons-boxes py-4">
                                <div class="d-flex align-items-center mb-4">
                                  <div class="mr-3 icon-box">
                                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                          <path d="M9.5 12.4L10.9286 14L14.5 10" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 14.4963 20.1632 16.4284 19 17.9041M3.19284 14C4.05026 18.2984 7.57641 20.5129 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C14.6796 21.2747 15.3324 20.9478 16 20.5328" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
                                      </svg>
                                  </div>
                                  <div>
                                     <h5 class="mb-1 font-weight-bold">Verified Listings</h5>
                                     <p class="m-0">All properties are checked</p>
                                  </div>
                                 </div>

                                 <div class="d-flex align-items-center mb-4">
                                      <div class="mr-3 icon-box">
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                                              <path d="M3.5 9.398C3.5 8.37292 3.5 7.86038 3.70266 7.47025C3.87343 7.14149 4.14149 6.87343 4.47025 6.70266C4.86038 6.5 5.37292 6.5 6.398 6.5H17.602C18.6271 6.5 19.1396 6.5 19.5298 6.70266C19.8585 6.87343 20.1266 7.14149 20.2973 7.47025C20.5 7.86038 20.5 8.37292 20.5 9.398V15.602C20.5 16.6271 20.5 17.1396 20.2973 17.5298C20.1266 17.8585 19.8585 18.1266 19.5298 18.2973C19.1396 18.5 18.6271 18.5 17.602 18.5H6.398C5.37292 18.5 4.86038 18.5 4.47025 18.2973C4.14149 18.1266 3.87343 17.8585 3.70266 17.5298C3.5 17.1396 3.5 16.6271 3.5 15.602V9.398Z" stroke="#000"/>
                                              <path d="M3.5 10.5L20.5 10.5" stroke="#000" stroke-linecap="round"/>
                                              <circle cx="6.5" cy="15.5" r="0.5" fill="#000"/>
                                          </svg>
                                  
                                      </div>
                                      <div>
                                          <h5 class="mb-1 font-weight-bold">No Hidden Fees</h5>
                                          <p class="m-0">Zero hidden charges</p>
                                      </div>
                                  </div>

                                  <div class="d-flex align-items-center">
                                      <div class="mr-3 icon-box">
                                        <svg style="width: 20px;" xmlns="http://www.w3.org/2000/svg" fill="#000" viewBox="0 0 16 16">
                                              <path d="M7.25 11.2v1.42h1.5V11.2a1.48 1.48 0 0 0 .85-1.32A1.55 1.55 0 0 0 8 8.38a1.55 1.55 0 0 0-1.6 1.5 1.48 1.48 0 0 0 .85 1.32z"/>
                                              <path d="M14.75 5H13.5A5.29 5.29 0 0 0 8 0a5.29 5.29 0 0 0-5.5 5H1.25A1.25 1.25 0 0 0 0 6.25v8.5A1.25 1.25 0 0 0 1.25 16h13.5A1.25 1.25 0 0 0 16 14.75v-8.5A1.25 1.25 0 0 0 14.75 5zM8 1.25A4.05 4.05 0 0 1 12.25 5h-8.5A4.05 4.05 0 0 1 8 1.25zm6.75 13.5H1.25v-8.5h13.5z"/>
                                          </svg>
                                      </div>
                                      <div>
                                          <h5 class="mb-1 font-weight-bold">Secure Payments</h5>
                                          <p class="m-0">Your money is protected</p>
                                      </div>
                                  </div>


                              </div>
                            </div>
                            <div v-if="discount && (
                              discount.oneweekdisc ||
                              discount.twoweekdisc ||
                              discount.threeweekdisc ||
                              discount.onemonthdis ||
                              discount.twomonthsdis ||
                              discount.threemonthsdis ||
                              discount.fourmonthsdis ||
                              discount.fivemonthsdis ||
                              discount.sixmonthsdis ||
                              discount.sevenmonthsdis ||
                              discount.eightmonthsdis
                            )" class="long_stay_dis discounts-list table-discounts-list">

                              <h4>{{ $t('Propertis.discount_on_long_stays') }}</h4>

                              <div class="long_dis align-items-center" v-if="discount.oneweekdisc">
                                <h5>{{ $t('Propertis.one_week') }} <span class=" ">-{{ discount.oneweekdisc }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.twoweekdisc">
                                <h5>{{ $t('Propertis.two_weeks') }} <span class=" ">-{{ discount.twoweekdisc }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.threeweekdisc">
                                <h5>{{ $t('Propertis.three_weeks') }} <span class=" ">-{{ discount.threeweekdisc
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.onemonthdis">
                                <h5>{{ $t('Propertis.one_month') }} <span class=" ">-{{ discount.onemonthdis }}%</span>
                                </h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.twomonthsdis">
                                <h5>{{ $t('Propertis.two_months') }} <span class=" ">-{{ discount.twomonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.threemonthsdis">
                                <h5>{{ $t('Propertis.three_months') }} <span class=" ">-{{ discount.threemonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.fourmonthsdis">
                                <h5>{{ $t('Propertis.four_months') }} <span class=" ">-{{ discount.fourmonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.fivemonthsdis">
                                <h5>{{ $t('Propertis.five_months') }} <span class=" ">-{{ discount.fivemonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.sixmonthsdis">
                                <h5>{{ $t('Propertis.six_months') }} <span class=" ">-{{ discount.sixmonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.sevenmonthsdis">
                                <h5>{{ $t('Propertis.seven_months') }} <span class=" ">-{{ discount.sevenmonthsdis
                                    }}%</span></h5>
                              </div>
                              <div class="long_dis align-items-center" v-if="discount.eightmonthsdis">
                                <h5>{{ $t('Propertis.eight_months') }} <span class=" ">-{{ discount.eightmonthsdis
                                    }}%</span></h5>
                              </div>
                            </div>
                           
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab :title="$t('Propertis.Property_Owner')">
                      <div class="product-detail-sec pt-2">
                        <div class="two-column">
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="row">
                                <div v-if="property.kitchen_available === 1" class="col-md-12">
                                  <div class="about-details row align-items-center">
                                    <div class="col-md-4">
                                      <div class="d-flex align-items-center air-condition pb-3 pb-md-0">
                                          <div class="image mr-3">
                                            <img :src="propertyOwnerAvatar" alt="image"
                                              style="border-radius: 50%;height: 45px; width: 45px; object-fit: cover;">
                                          </div>
                                           <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Property_Owner') }}</h5>
                                      </div>
                                     
                                    </div>
                                    <div class="col-md-8">
                                      <div class="d-flex align-items-center"> 
                                        <p class="mb-0">{{ property.user.name }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-12"><hr /></div>
                                <div class="col-md-12">
                                  <div class="about-details row">
                                    <div class="col-md-4">
                                       <div class="air-condition pb-3 pb-md-0">
                                        <span><i class="fa fa-file-text" aria-hidden="true"></i> </span>
                                         <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Description') }}</h5>
                                       </div>
                                     
                                    </div>
                                    <div class="col-md-8"> 
                                      <p class="mb-0">{{ property.property_description }}</p>
                                    </div>
                                    <div class="col-md-12"><hr /></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!---------->
                        <div class="two-column" v-if="false">
                          <div class="row align-items-center">
                            <div class="col-md-4">
                              <div class="heading air-condition pb-3 pb-md-0">
                                <span><i class="fa fa-star" aria-hidden="true"></i></span>
                                <h5 class="font-weight-bold mb-0">{{ $t('property_detail.Reviews') }}</h5>
                              </div>
                            </div>
                            <div class="col-md-8">
                              <div class="popular-amenities mb-0">
                                <ul>
                                  <li>
                                    <div class="stars">
                                      <span class="fa fa-star" :class="{ 'checked': rating >= 1 }"></span>
                                      <span class="fas fa-star" :class="{ 'checked': rating >= 2 }"></span>
                                      <span class="fas fa-star" :class="{ 'checked': rating >= 3 }"></span>
                                      <span class="fas fa-star" :class="{ 'checked': rating >= 4 }"></span>
                                      <span class="fas fa-star" :class="{ 'checked': rating >= 5 }"></span>
                                    </div>
                                  </li>
                                  <li>
                                    <div class="air-condition pb-3 pb-md-0">
                                      <a href="#" @click.prevent="redirectToRating"><span class="review-no font-weight-bold">{{ reviews
                                      }} {{
                                            $t('property_detail.Reviews') }} </span></a>
                                    </div>
                                  </li>
                                  <li>
                                    <div class="air-condition pb-0">

                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-12 p-0" v-if="false"><hr /></div>
                        <!---------->
                        <div class="two-column">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="heading air-condition pb-3 pb-md-0">
                                 <span><i class="fa fa-adjust" aria-hidden="true"></i></span>
                                <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Damage_and_incidentals') }}</h5>
                              </div>
                            </div>
                            <div class="col-md-8">
                              <div class="paragrapgh">
                                <p>{{ $t('Propertis.demage_responsoble') }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                         <div class="col-md-12 p-0"><hr /></div>
                        <div class="two-column">
                          <div class="row">
                            <div class="col-lg-4">
                              <div class="heading air-condition pb-3 pb-md-0">
                                <span><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                                <h5 class="font-weight-bold mb-0">{{ $t('Propertis.Important_information') }}</h5>
                              </div>
                            </div>
                            <div class="col-lg-8">
                              <div class="popular-amenities important-information">
                                <ul>

                                </ul>
                                <div class="paragrapgh">

                                  <p class="font-weight-bold mb-3">
                                    {{ $t('Propertis.house_rules_message') }}
                                  </p> 
                                  <ul style="flex-direction: column; row-gap: 10px;" class="important-information-list">
                                    <li v-if="property.children">
                                      <span>{{ $t('Propertis.Children_are', {
                                        children:
                                          translatePolicy(property.children, 'Children')
                                      })
                                      }}</span>
                                    </li>
                                    <li v-if="property.Events">
                                      <span>{{ $t('Propertis.Events_are', {
                                        events: translatePolicy(property.Events,
                                          'Events')
                                      }) }}</span>
                                    </li>
                                    <li v-if="property.Pets">
                                      <span>{{ $t('Propertis.Pets_are', {
                                        pets: translatePolicy(property.Pets, 'Pets')
                                      }) }}</span>
                                    </li>
                                    <li v-if="property.Smoking">
                                      <span>{{ $t('Propertis.Smoking_is', {
                                        smoking: translatePolicy(property.Smoking,
                                          'Smoking')
                                      })
                                      }}</span>
                                    </li>
                                  </ul>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!---------->
                        <div class="two-column"
                          v-if="property.user_id !== currentUserId && currentUserId !== null">
                          <div class="row">
                            <div class="col-lg-4">
                              <div class="heading">
                                <h2>{{ $t('Propertis.send_message_to_owner') }}</h2>
                              </div>
                            </div>
                            <div class="col-lg-8">
                              <div v-if="messageSent">
                                <p class="text-success">
                                  {{ $t('Propertis.message_sent_success') }}
                                  <span class="text-primary cursor-pointer" @click="messages()">
                                    {{ $t('Propertis.click_here') }}
                                  </span> {{ $t('Propertis.for_further_chat') }}
                                </p>
                              </div>
                              <form v-else @submit.prevent="handleSendMessage" class="send-message">

                                <div class="form-group">
                                  <textarea class="form-control" id="message" v-model="textForm.message"
                                    :class="{ 'is-invalid': textFormErrors.message }" rows="5"
                                    :placeholder="$t('Propertis.enter_message')" :disabled="isSending"></textarea>
                                  <div class="invalid-feedback">{{ textFormErrors.message }}</div>
                                </div>

                                <button type="submit" class="btn btn-primary" :disabled="isSending"
                                  :class="{ disabled: isSending }">{{
                                    $t('Propertis.start_chat')
                                  }}</button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-scrollable" scrollable hide-footer :title="$t('Propertis.property_amenities')">
      <div class="popular-amenities mb-2">
        <h3>{{ $t('Propertis.Amenities') }}</h3>
        <ul>
          <li v-if="property.kitchen_available === 1">
            <div class="air-condition">
              <span><i class="fas fa-utensils"></i></span>
              <span>{{ $t('Propertis.Kitchen') }}</span>
            </div>
          </li>
          <li v-if="property.tv_available === 1">
            <div class="air-condition">
              <span><i class="fa fa-tv" aria-hidden="true"></i></span>
              <span>{{ $t('Propertis.TV') }}</span>
            </div>
          </li>
          <li v-if="property.wifi_available === 1">
            <div class="air-condition">
              <span><i class="fa fa-wifi" aria-hidden="true"></i></span>
              <span>{{ $t('Propertis.Wifi') }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div>
        <div class="popular-amenities mb-2" v-if="property.wifi_available === 1">
          <h3>{{ $t('Propertis.Internet') }}</h3>
          <ul>
            <li>{{ $t('Propertis.Available_in_apartment') }}</li>
          </ul>
        </div>
      </div>
      <div class="popular-amenities mb-2">
        <h3>{{ $t('Propertis.Bedrooms') }}</h3>
        <ul>
          <li>
            <div class="air-condition">
              <span><i class="fa fa-bed" aria-hidden="true"></i></span>
              <span>{{ property.num_bedrooms }} {{ bedroomLabel }}
              </span>
            </div>
          </li>
          <li v-if="property.king_size_bed > 0">
            {{ property.king_size_bed }} {{ bedLabel(property.king_size_bed, 'king') }}
          </li>
          <li v-if="property.queen_size_bed > 0">
            {{ property.queen_size_bed }} {{ bedLabel(property.queen_size_bed, 'queen') }}
          </li>
          <li v-if="property.sofa_bed > 0">
            {{ property.sofa_bed }} {{ bedLabel(property.sofa_bed, 'sofa') }}
          </li>
        </ul>
      </div>
      <div class="popular-amenities mb-2">
        <h3>{{ $t('Propertis.Bathroom') }}</h3>
        <ul>
          <li>
            <div class="air-condition">
              <span><i class="fa fa-bath" aria-hidden="true"></i></span>
              <span>{{ property.num_bathrooms }} {{ bathroomLabel }} </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="popular-amenities mb-2">
        <h3>{{ $t('property_detail.Bathroom_Amenities') }}</h3>
        <ul>
          <li v-for="amenity in parsedBathroomAmenities" :key="amenity" class="bathroom-amenity-item">
            <span>{{ getTranslatedAmenity(amenity) }}</span>
          </li>
        </ul>
      </div>

    </b-modal>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted, onUpdated } from 'vue'

const isSticky = ref(false)
let tabsContainer = null
let stickyOffset = 0

// Target the actual tabs nav (the part that should be sticky)
const updateStickyOffset = () => {
  if (window.innerWidth > 580) {
    isSticky.value = false
    return
  }

  tabsContainer = document.querySelector('.vue-tabslist')

  if (tabsContainer) {
    stickyOffset = tabsContainer.getBoundingClientRect().top + window.pageYOffset
  }
}

const handleScroll = () => {
  if (!tabsContainer) return

  if (window.innerWidth <= 580) {
    isSticky.value = window.pageYOffset >= stickyOffset - 1 // Slight buffer
  } else {
    isSticky.value = false
  }
}

onUpdated(() => {
  updateStickyOffset()
})

onMounted(() => {
  updateStickyOffset()
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', updateStickyOffset)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', updateStickyOffset)
})
</script>
<script>
import API from '@/api';
import DateRangePicker from 'vue2-daterange-picker';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from '@fancyapps/ui';
import moment from 'moment';
import Swal from 'sweetalert2';
import Vue from 'vue';
import axios from 'axios';
import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);
import { Loader } from '@googlemaps/js-api-loader';

export default {
  name: 'propertyDetail',
  components: {
    DateRangePicker,
  },
  data() {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    const date = new Date();
    date.setDate(date.getDate() + 20);
    const rfdate = new Date();
    rfdate.setDate(rfdate.getDate() + 4);
    const options = { month: 'short', day: '2-digit' };
    const formattedDate = rfdate.toLocaleDateString('en-US', options);
    return {
      currentSlide: 0,
      activeTab: '',
      currentUserId: null,
      offerPriceError: '',
      differenceInDays: 0,
      isLoading: false,
      offersData: [],
      previousOffersData: [],
      remainingAttempts: 0,
      totalPreviousOffers: 0,
      perPage: 10,
      currentPage: 1,
      newOfferPropertyIds: [],
      targetDate: 0,
      targetTime: 0,
      remainingTime: 0,
      timer: null,
      orginalguest: '',
      userHasMadeOffer: false,
      time1: null,
      time2: null,
      time3: null,
      ftoday: date,
      isPopupVisible: false,
      isPopupVisible1: false,
      isPopupVisible2: false,
      isPopupVisible3: false,
      isPopupVisible4: false,
      isPopupVisible5: false,
      quantity: 1,
      childQuantity: 0,
      petQuantity: 0,
      rfdate: formattedDate,
      today: today,
      totalPrice1: 0,
      totalPrice2: 0,
      totaldicPrice1: 0,
      discountAmount: 0,
      longdis: null,
      pfprice: null,
      pffprice: null,
      pfDisprice: null,
      pffDisprice: null,
      currency: null,
      localeKey: 0,
      property: {},
      discount: {},
      flashDiscount: {},
      ratingVal: {},
      baseUrl: '',
      activeIndex: 0,
      booked: false,
      offeredPrice: null,
      invalidOfferPrice: false,
      start_Date: null,
      end_Date: null,
      numberOfNights: 0,
      rating: 0,
      reviews: 0,
      slide: 0,
      sliding: null,
      dateRange: {
        startDate: today,
        endDate: tomorrow,
      },
      sdate: moment(today).format('DD-MM-YYYY'),
      edate: moment(tomorrow).format('DD-MM-YYYY'),
      minDaysToStay: '',
      placeholder: 'Select Date Range',
      format: 'YYYY-MM-DD',
      form: {
        message: '',
        property_id: null,
      },
      textForm: {
        message: '',
      },
      isSending: false,
      textFormErrors: {
        message: '',
      },
      formErrors: {
        message: '',
      },
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      totalPrice: 0,
      disabledDates: [],
      map: null,
      exploreMap: null,
      address: '',
      currentLanguage: '',
      fullrefund: false,
      parrefund: false,
      nrefund: false,
      isLogedin: localStorage.getItem('isLoggedin'),
      messageSent: false,
      conversation_id: '',
      loading: true,
      loaderGif: 'https://www.vanovy.com/public/images/loading.gif',
      overlapDetected: false,
      propertyOwnerAvatar : 'http://bootdey.com/img/Content/avatar/avatar1.png',
    };
  },
  computed: {
    parsedBathroomAmenities() {
      try {
        return Array.isArray(this.property.bathroom_Amenities)
          ? this.property.bathroom_Amenities
          : JSON.parse(this.property.bathroom_Amenities || '[]');
      } catch (error) {
        console.warn('Invalid bathroom amenities JSON:', error);
        return [];
      }
    },
    bedroomLabel() {
      return this.property.num_bedrooms === 1
        ? this.$t('Propertis.Bedroom')
        : this.$t('Propertis.Bedrooms');
    },
    bathroomLabel() {
      return this.property.num_bathrooms === 1
        ? this.$t('Propertis.Bathroom')
        : this.$t('Propertis.Bathrooms');
    },
    computedTitle() {
      const type = this.property?.property_type || 'default_type';
      const accommodation = this.property?.accommodation_type || '';
      const city = this.property?.city || '';
      const country = this.property?.country || '';
      return `${this.$t('property_detail.' + type)} ${accommodation} in ${city}, ${country}.`;
    },
    hasMadeOffer() {
      return this.userHasMadeOffer;
    },
    startDateValue() {
      return this.dateRange?.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : null;
    },
    endDateValue() {
      return this.dateRange?.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : null;
    },
    showMakeAnotherOffer() {
      const noPendingOffers = this.offersData.every((offer) => offer.status !== 'pending');
      const allRejectedOrAcceptedBooked = this.offersData.every((offer) => {
        return (
          offer.status === 'rejected' ||
          (offer.status === 'accepted' && offer.is_booked === 1)
        );
      });
      return this.remainingAttempts > 0 && noPendingOffers && allRejectedOrAcceptedBooked;
    },
    translateOfferStatus(statusKey) {
      if (!statusKey) return this.$t('offers.status_pending'); // fallback
      const key = String(statusKey).toLowerCase();
      const i18nKey = `offers.status_${key}`;
      const translated = this.$t(i18nKey);
      return translated && translated !== i18nKey ? translated : statusKey;
    },
    totalPrice1Formatted() {
      return this.currency + ' ' + parseFloat(this.totalPrice1).toFixed(2);
    },
    minOfferPrice() {
      return this.totalPrice1 * 0.3;
    },
    minOfferPriceFormatted() {
      return this.currency + ' ' + (this.totalPrice1 * 0.3).toFixed(2);
    },
    showTimer() {
      // return this.remainingTime <= 24 * 60 * 60 * 1000;
      return this.remainingTime > 0 && this.remainingTime <= 24 * 60 * 60 * 1000;
    },
    formattedTime() {
      const milliseconds = this.remainingTime;
      const totalSeconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${hours}h ${minutes}m ${seconds}s`;
    },
    formattedRating() {
      return this.rating.toFixed(2);
    },
    partialRefundStyle() {
      if (this.fullrefund) {
        return { 'margin-left': '25%' };
      } else {
        return { 'margin-left': '59%' };
      }
    },
    noRefundStyle() {
      if (this.fullrefund) {
        return { 'margin-left': '0%' };
      } else if (this.parrefund) {
        return { 'margin-left': '30%' };
      } else {
        return { 'margin-left': '60%' };
      }
    },
    prefund() {
      const futureDate = new Date(this.ftoday);
      futureDate.setDate(futureDate.getDate() - 8);
      const options = { month: 'short', day: '2-digit' };
      return futureDate.toLocaleDateString('en-US', options);
    },
    crefund() {
      const futureDate = new Date(this.ftoday);
      futureDate.setDate(futureDate.getDate() - 15);
      const options = { month: 'short', day: '2-digit' };
      return futureDate.toLocaleDateString('en-US', options);
    },
    pprice() {
      return this.property ? this.property : null;
    },
    currentPageUrl() {
      return window.location.href;
    },
    getDisplayPrice() {
      if (this.differenceInDays === 0) {
        return this.property.price_per_month
          ? Math.round(parseFloat(this.property.price_per_month.toString().replace(/,/g, '')))
          : Math.round(parseFloat(this.pfprice || 0));
      }
      return Math.round(parseFloat(this.totalPrice1 || this.pfprice || 0));
    },
    getPricePeriod() {
      // Monthly pricing mode (when no dates selected or special case)
      if (this.differenceInDays === 0) {
        return this.$t('property_detail.month');
      }

      const totalNights = this.differenceInDays;
      const months = Math.floor(totalNights / 30);
      const remainingNights = totalNights % 30;

      // Helper: get correct translation for "night" singular/plural
      const tNight = (count) => {
        return count === 1
          ? this.$t('property_detail.night')
          : this.$t('Propertis.nights');
      };

      // Helper: get correct translation for "month" singular/plural
      const tMonth = (count) => {
        return count === 1
          ? this.$t('property_detail.month')
          : this.$t('property_detail.months'); // make sure you have "months" key
      };

      // Case 1: Only months (e.g. 60 nights → 2 months)
      if (remainingNights === 0) {
        return `${months} ${tMonth(months)}`;
      }

      // Case 2: Months + nights (e.g. 35 nights → 1 month and 5 nights)
      if (months > 0) {
        return `${months} ${tMonth(months)} ${this.$t('common.and')} ${remainingNights} ${tNight(remainingNights)}`;
      }

      // Case 3: Only nights (e.g. 25 nights → 25 nights)
      return `${totalNights} ${tNight(totalNights)}`;
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.localeKey++;
        this.updateTranslations();
      },
      immediate: true,
    },
    isPopupVisible(visible) {
      if (visible) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    isPopupVisible1(visible) {
      if (visible) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    isPopupVisible2(visible) {
      if (visible) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    isPopupVisible3(visible) {
      if (visible) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    isPopupVisible4(visible) {
      if (visible) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    isPopupVisible5(visible) {
      if (visible) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    totalPrice1(newVal) {
      if (newVal <= 0) {
        this.offeredPrice = null;
        this.validateOfferPrice(); // re-trigger validation to show correct message
      }
    },
    dateRange: {
      deep: true,
      handler(newVal) {
        if (!newVal || !newVal.startDate || !newVal.endDate) {
          this.differenceInDays = 0;
          this.totalPrice1 = 0;
          this.totalPrice2 = 0;
          this.totaldicPrice1 = 0;
          this.discountAmount = 0;
          this.longdis = null;
          this.pfDisprice = this.property.discountedPrice || 0;
          this.pffDisprice = this.pfDisprice;
          this.fullrefund = false;
          this.parrefund = false;
          this.nrefund = false;
          this.loading = false;
          this.sdate = moment(this.today).format('DD-MM-YYYY');
          this.edate = moment(this.tomorrow).format('DD-MM-YYYY');
          return;
        }
        const startMoment = moment(newVal.startDate);
        const endMoment = moment(newVal.endDate);
        const tomorrow = moment(this.today).add(1, 'days');
        if (startMoment.isSame(this.today, 'day') && endMoment.isSame(tomorrow, 'day')) {
          this.differenceInDays = 0;
          this.totalPrice1 = 0;
          this.totalPrice2 = 0;
          this.totaldicPrice1 = 0;
          this.discountAmount = 0;
          this.longdis = null;
          this.pfDisprice = this.property.discountedPrice || 0;
          this.pffDisprice = this.pfDisprice;
          this.fullrefund = false;
          this.parrefund = false;
          this.nrefund = false;
          this.loading = false;
          this.sdate = moment(newVal.startDate).format('DD-MM-YYYY');
          this.edate = moment(newVal.endDate).format('DD-MM-YYYY');
          return;
        }
        this.loading = false;
        const minDaystoStay = this.property.min_night_stay || 1;
        const maxDaystoStay = this.property.max_night_stay || 365;
        const differenceInDays = endMoment.diff(startMoment, 'days');
        this.differenceInDays = differenceInDays;
        this.sdate = startMoment.format('DD-MM-YYYY');
        this.edate = endMoment.format('DD-MM-YYYY');

        console.log('differenceInDays:',differenceInDays);
        if (differenceInDays < minDaystoStay || differenceInDays > maxDaystoStay) {
          console.log('111111111111111111111111111111111111111111111111111');
          let stayError = differenceInDays < minDaystoStay
            ? this.$t('validations.min_stay', { days: minDaystoStay })
            : this.$t('validations.max_stay', { days: maxDaystoStay });
          Swal.fire({
            type: 'error',
            title: this.$t('alerts.error'),
            text: stayError,
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'error',
          });
          this.resetDateRange();
          return;
        }

        if (startMoment.isBefore(moment(), 'day')) {
          Swal.fire({
            type: 'error',
            title: this.$t('sweetalert.Invalid_Date'),
            text: this.$t('sweetalert.f_dates'),
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'error',
          });
          this.resetDateRange();
          return;
        }

        if (this.checkDateOverlap(startMoment, endMoment)) {
          this.overlapDetected = true;
          Swal.fire({
            type: 'error',
            title: this.$t('sweetalert.Oops'),
            text: this.$t('sweetalert.overlap'),
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'warning',
          }).then((result) => {
            if (result.isConfirmed) {
              this.resetDateRange();
            }
          });
          return;
        }

        this.calculatePricing();
        const today = moment();
        const daysFromToday = startMoment.diff(today, 'days');
        this.ftoday = startMoment.toDate();
        this.fullrefund = daysFromToday > 15;
        this.parrefund = daysFromToday > 10 && daysFromToday <= 15;
        this.nrefund = daysFromToday <= 10;

        if (!newVal.startDate || !newVal.endDate || this.totalPrice1 <= 0) {
          this.offeredPrice = null;
        }
      },
    },
  },
  mounted() {
    this.checkIsDemoProperty();
    const user = JSON.parse(localStorage.getItem('user'));
    this.currentUserId = user ? user.id : null;
    const propertyId = sessionStorage.getItem('propertyId');
    this.getProperty(propertyId);
    this.getRatingAndReviews(propertyId);
    this.getBookingsByPropertyID(propertyId);
    this.checkIfUserHasMadeOffer(propertyId);
    this.fetchPreviousOffersData();
    this.$root.$on('currency-changed', (newCurrency) => {
      this.recalculatePrices(newCurrency);
    });
    Vue.prototype.$EventBus.$on('changeLanguage', this.onLanguageChanged);
    Fancybox.bind('[data-fancybox]', {
      loop: true,
      buttons: ['zoom', 'slideShow', 'thumbs', 'close'],
    });
    Vue.prototype.$EventBus.$on('clear-dates', () => {
      this.resetDateRange();
    });
    // Set initial datepicker range
    this.$nextTick(() => {
      if (this.$refs.datePickerRef?.picker) {
        this.$refs.datePickerRef.picker.setStartDate(this.today);
        this.$refs.datePickerRef.picker.setEndDate(this.tomorrow);
      }
    });
  },
  methods: {
    checkIsDemoProperty() {
      const propertyId = sessionStorage.getItem('propertyId');
      //local demo ids
      // const demoIds = [1, 2, 3, 4, 5, 6, 7, 8, 9,10,11,12,13,14,15];  //local demo ids
      const demoIds = [1, 2, 3, 4, 5, 6, 7, 8, 9,10,11,12,13,14,15,16];    //live demo ids
      const status = propertyId ? demoIds.includes(parseInt(propertyId)) : false;
      return status;
    },
    resetDateRange() {
      const today = new Date();
      const defaultEndDate = new Date(today);
      defaultEndDate.setDate(
        today.getDate() + (parseInt(this.property?.min_night_stay || 1, 10))
      );

      this.dateRange = {
        startDate: today,
        endDate: defaultEndDate,
      };

      this.sdate = moment(today).format('DD-MM-YYYY');
      this.edate = moment(defaultEndDate).format('DD-MM-YYYY');
      this.differenceInDays = 0;
      this.totalPrice1 = 0;
      this.totalPrice2 = 0;
      this.totaldicPrice1 = 0;
      this.discountAmount = 0;
      this.longdis = null;
      this.pfDisprice = this.property.discountedPrice || 0;
      this.pffDisprice = this.pfDisprice;
      this.fullrefund = false;
      this.parrefund = false;
      this.nrefund = false;
      if (this.$refs.datePickerRef?.picker) {
        this.$refs.datePickerRef.picker.setStartDate(today);
        this.$refs.datePickerRef.picker.setEndDate(defaultEndDate);
      }
      this.updatePropertyAvailability();
    },
    translateOfferStatusTable(statusKey) {
      if (!statusKey) return this.$t('offers.status_pending'); // fallback
      const key = String(statusKey).trim().toLowerCase();
      const i18nKey = `offers.status_${key}`;
      const translated = this.$t(i18nKey);
      return translated && translated !== i18nKey
        ? translated
        : key.charAt(0).toUpperCase() + key.slice(1);
    },
    updatePropertyAvailability() {
      const propertyId = sessionStorage.getItem('propertyId');
      if (propertyId) {
        this.getBookingsByPropertyID(propertyId);
      }
    },
    formatDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '';
    },
    translatePolicy(value, category) {
      if (!value) return this.$t('common.none');
      const normalizeKey = (str) => {
        if (!str) return 'Not_Allowed';
        const lower = str.toString().toLowerCase().trim();
        if (lower === 'yes' || lower === '1') return 'Allowed';
        if (lower === 'no' || lower === '0') return 'Not_Allowed';
        return str
          .trim()
          .replace(/\s+/g, '_')
          .replace(/Allowd/g, 'Allowed')
          .replace(/[^a-zA-Z0-9:()_-]/g, '');
      };
      const normalizedKey = normalizeKey(value);
      const translationKey = `Propertis.Policies.${category}.${normalizedKey}`;
      if (this.$te(translationKey)) {
        return this.$t(translationKey);
      }
      const lower = value.toString().toLowerCase();
      if (lower.startsWith('allowed')) {
        const prefix = this.$t('common.allowed');
        const detail = value.split(':').slice(1).join(':').trim();
        return detail ? `${prefix}: ${detail}` : prefix;
      }
      if (
        lower === 'not allowed' ||
        lower === 'not_allowd' ||
        lower === 'not_allowed' ||
        lower === 'no' ||
        lower === '0'
      ) {
        return this.$t('common.not_allowed');
      }
      if (lower === 'yes' || lower === '1') {
        return this.$t('common.allowed');
      }
      return value;
    },
    getTranslatedAmenity(amenity) {
      if (!amenity) return '';
      const key = amenity.trim().replace(/\s+/g, '_');
      const propertyKey = `Propertis.${key}`;
      const detailKey = `property_detail.${key}`;
      if (this.$te(propertyKey)) {
        return this.$t(propertyKey);
      } else if (this.$te(detailKey)) {
        return this.$t(detailKey);
      }
      return amenity.replaceAll('_', ' ');
    },
    formatMonthDuration(days) {
      const months = Math.floor(days / 30);
      const remainingDays = days % 30;
      const getTranslatedUnit = (unit, count) => {
        return count > 1 ? this.$t(`property_detail.${unit}s`) : this.$t(`property_detail.${unit}`);
      };

      if (months > 0 && remainingDays > 0) {
        return `${months} ${getTranslatedUnit('month', months)} ${this.$t('property_detail.to')} ${remainingDays} ${getTranslatedUnit('day', remainingDays)}`;
      } else if (months > 0) {
        return `${months} ${getTranslatedUnit('month', months)}`;
      } else {
        return `${days} ${getTranslatedUnit('day', days)}`;
      }
    },
    bedLabel(count, type) {
      const labels = {
        king: ['property_detail.king_bed', 'property_detail.king_beds'],
        queen: ['property_detail.queen_bed', 'property_detail.queen_beds'],
        sofa: ['property_detail.sofa_bed', 'property_detail.sofa_beds'],
      };

      const [singularKey, pluralKey] = labels[type] || [];
      if (!singularKey || !pluralKey) return ''; // fallback for unexpected type

      return count === 1 ? this.$t(singularKey) : this.$t(pluralKey);
    },
    updateCountdown() {
      const now = new Date().getTime();
      this.remainingTime = this.targetTime - now;
      if (this.remainingTime <= 0) {
        clearInterval(this.timer);
        this.remainingTime = 0;
      }
    },
    ucfirst(str) {
      if (!str) return str;
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    sharedViewModal() {
      if (localStorage.getItem('isLoggedin')) {
        if (this.dateRange?.startDate && this.dateRange?.endDate && this.dateRange.startDate.getTime() !== this.dateRange.endDate.getTime()) {
          this.calculatePricing();
        }
        this.$refs['shared-modal'].show();
      } else {
        this.$bvModal.show('modal-4');
      }
    },
    viewMyOffers() {
      if (localStorage.getItem('isLoggedin')) {
        if (!this.dateRange.startDate || !this.dateRange.endDate || this.dateRange.startDate.getTime() === this.dateRange.endDate.getTime()) {
          alert('Please Select Available Dates.');
        } else {
          this.fetchOffersData();
          this.$refs['my-offers-modal'].show();
        }
      } else {
        this.$bvModal.show('modal-4');
      }
    },
    showOffersModal() {
      this.fetchOffersData();
      this.$refs['my-offers-modal'].show();
    },
    fetchOffersData() {
      const propertyId = sessionStorage.getItem('propertyId');
      API.getUserOfferData({ property_id: propertyId }, (data) => {
        if (data.hasOffer) {
          this.offersData = data.offersData;
          this.remainingAttempts = data.remainingAttempts;
        } else {
          this.offersData = [];
          this.remainingAttempts = data.remainingAttempts;
        }
      });
    },
    fetchPreviousOffersData(page = 1) {
      const propertyId = sessionStorage.getItem('propertyId');
      API.getUserPreviousOfferData({ property_id: propertyId, page }, (data) => {
        if (data.hasOffer) {
          this.previousOffersData = data.offersData;
          this.totalPreviousOffers = data.totalOffers;
          this.perPage = data.perPage;
          this.currentPage = data.currentPage;
        } else {
          this.previousOffersData = [];
          this.totalPreviousOffers = 0;
        }
      });
    },
    onPageChange(page) {
      this.fetchPreviousOffersData(page);
    },
    bookNow(offer) {
      if (!offer.start_date || !offer.end_date) {
        alert('Offer dates are not available.');
        return;
      }
      const startDate = moment(offer.start_date);
      const formattedStartDate = startDate.format('YYYY-MM-DD');
      const endDate = moment(offer.end_date);
      const formattedEndDate = endDate.format('YYYY-MM-DD');
      const daysDifference = endDate.diff(startDate, 'days');
      this.$router.push({
        name: 'property_payment',
        params: {
          guestnumber: offer.no_of_guests,
          prefund: this.prefund,
          nrefund: this.nrefund,
          parrefund: this.parrefund,
          days: daysDifference,
          totalPrice1: offer.offered_price,
          pfprice: offer.offer_per_night_price,
          currency: offer.currency,
          totalPrice: offer.original_price,
          totaldicPrice1: offer.offered_price,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          is_booked: true,
          offer_id: offer.id,
          discount_object: JSON.stringify(this.discount),
        },
      });
    },
    makeAnotherOffer(offer) {
      this.$refs['my-offers-modal'].hide();
      this.sharedViewModal();
    },
    togglePopup() {
      this.isPopupVisible = !this.isPopupVisible;
    },
    togglePopup1() {
      this.isPopupVisible1 = !this.isPopupVisible1;
    },
    togglePopup2() {
      this.isPopupVisible2 = !this.isPopupVisible2;
    },
    togglePopup3() {
      this.isPopupVisible3 = !this.isPopupVisible3;
    },
    togglePopup4() {
      this.isPopupVisible4 = !this.isPopupVisible4;
    },
    togglePopup5() {
      this.isPopupVisible5 = !this.isPopupVisible5;
    },
    handleClickOutside(event) {
      const popups = [
        { ref: 'popup', prop: 'isPopupVisible', toggle: 'toggle' },
        { ref: 'popup1', prop: 'isPopupVisible1', toggle: 'toggle1' },
        { ref: 'popup2', prop: 'isPopupVisible2', toggle: 'toggle2' },
        { ref: 'popup3', prop: 'isPopupVisible3', toggle: 'toggle3' },
        { ref: 'popup4', prop: 'isPopupVisible4', toggle: 'toggle4' },
        { ref: 'popup5', prop: 'isPopupVisible5', toggle: 'toggle5' },
      ];
      popups.forEach(({ ref, prop, toggle }) => {
        const popup = this.$refs[ref];
        const toggleRef = this.$refs[toggle];
        if (
          popup &&
          !popup.contains(event.target) &&
          toggleRef &&
          !toggleRef.contains(event.target)
        ) {
          this[prop] = false;
        }
      });
    },
    increment() {
      this.property.max_guests++;
      this.calculatePricing();
    },
    decrement() {
      if (this.property.max_guests > 1) {
        this.property.max_guests--;
        this.calculatePricing();
      }
    },
    async recalculatePrices(newCurrency) {
      try {
        const oldCurrency = this.currency;
        this.currency = newCurrency;
        const currentPfPrice = this.pfprice || this.property.price;
        const currentDiscountedPrice = this.pfDisprice || this.property.discountedPrice;
        const currentMonthlyPrice = this.property.price_per_month;
        if (currentPfPrice && oldCurrency && oldCurrency !== newCurrency) {
          const response = await fetch(`https://api.exchangerate-api.com/v4/latest/${oldCurrency}`);
          const data = await response.json();
          if (data && data.rates) {
            const conversionRate = data.rates[newCurrency];
            if (conversionRate) {
              this.pfprice = (currentPfPrice * conversionRate).toFixed(2);
              this.pffprice = this.pfprice;
              if (currentDiscountedPrice) {
                this.pfDisprice = (currentDiscountedPrice * conversionRate).toFixed(2);
                this.pffDisprice = this.pfDisprice;
              }
              if (currentMonthlyPrice) {
                const cleanPrice = parseFloat(currentMonthlyPrice.toString().replace(/,/g, ''));
                this.property.price_per_month = (cleanPrice * conversionRate).toLocaleString();
              }
              if (this.dateRange.startDate && this.dateRange.endDate && this.dateRange.startDate.getTime() !== this.dateRange.endDate.getTime()) {
                this.calculatePricing();
              }
              if (this.offersData && this.offersData.length > 0) {
                this.offersData.forEach(offer => {
                  if (offer.currency === oldCurrency) {
                    offer.currency = newCurrency;
                    offer.offered_price = (offer.offered_price * conversionRate).toFixed(2);
                    offer.original_price = (offer.original_price * conversionRate).toFixed(2);
                    offer.offer_per_night_price = (offer.offer_per_night_price * conversionRate).toFixed(2);
                  }
                });
              }
            }
          }
        }
      } catch (error) {
        console.error('Error in currency conversion:', error);
        if (!this.pfprice && this.property.price) {
          this.pfprice = this.property.price;
          this.pffprice = this.property.price;
        }
        this.pfDisprice = this.property.discountedPrice || 0;
        this.pffDisprice = this.pfDisprice;
      }
    },
    calculatePricing() {
      if (!this.dateRange.startDate || !this.dateRange.endDate || this.dateRange.startDate.getTime() === this.dateRange.endDate.getTime()) {
        this.totalPrice1 = 0;
        this.totalPrice2 = 0;
        this.totaldicPrice1 = 0;
        this.discountAmount = 0;
        this.longdis = null;
        this.pfDisprice = this.property.discountedPrice || 0;
        this.pffDisprice = this.pfDisprice;
        this.pfprice = this.property.price.toFixed(2) || 0; // reset to base
        return;
      }

      const startMoment = moment(this.dateRange.startDate);
      const endMoment = moment(this.dateRange.endDate);
      const tomorrow = moment(this.today).add(1, 'days');
      if (startMoment.isSame(this.today, 'day') && endMoment.isSame(tomorrow, 'day')) {
        this.totalPrice1 = 0;
        this.totalPrice2 = 0;
        this.totaldicPrice1 = 0;
        this.discountAmount = 0;
        this.longdis = null;
        this.pfDisprice = this.property.discountedPrice || 0;
        this.pffDisprice = this.pfDisprice;
        this.pfprice = this.property.price.toFixed(2) || 0;
        return;
      }

      const differenceInDays = endMoment.diff(startMoment, 'days');
      this.differenceInDays = differenceInDays;

      // === GUEST ADJUSTMENT ===
      const baseGuestCount = this.orginalguest || 2;
      const currentGuests = this.property.max_guests;
      const guestMultiplier = currentGuests / baseGuestCount;

      // === BASE PRICE PER NIGHT (before discount) ===
      const baseNightlyPrice = this.pffprice || this.property.price || 0;
      const adjustedNightlyPrice = baseNightlyPrice * guestMultiplier;

      // === UPDATE pfprice TO REFLECT CURRENT GUESTS ===
      this.pfprice = adjustedNightlyPrice.toFixed(2);  // ← THIS IS THE KEY FIX

      // === TOTAL BEFORE DISCOUNT ===
      const baseTotal = adjustedNightlyPrice * differenceInDays;
      this.totalPrice2 = baseTotal.toFixed(2);

      // === LONG-STAY DISCOUNT LOGIC ===
      let discount = 0;
      if (differenceInDays >= 7 && differenceInDays < 14) {
        discount = this.discount.oneweekdisc || 0;
      } else if (differenceInDays >= 14 && differenceInDays < 21) {
        discount = this.discount.twoweekdisc || 0;
      } else if (differenceInDays >= 21 && differenceInDays < 28) {
        discount = this.discount.threeweekdisc || 0;
      } else if (differenceInDays >= 28) {
        const months = Math.floor(differenceInDays / 30);
        switch (months) {
          case 1: discount = this.discount.onemonthdis || 0; break;
          case 2: discount = this.discount.twomonthsdis || 0; break;
          case 3: discount = this.discount.threemonthsdis || 0; break;
          case 4: discount = this.discount.fourmonthsdis || 0; break;
          case 5: discount = this.discount.fivemonthsdis || 0; break;
          case 6: discount = this.discount.sixmonthsdis || 0; break;
          case 7: discount = this.discount.sevenmonthsdis || 0; break;
          default:
            if (months >= 8) discount = this.discount.eightmonthsdis || 0;
        }
      }

      const discountAmount = (baseTotal * discount) / 100;
      this.discountAmount = discountAmount.toFixed(2);
      this.totalPrice1 = (baseTotal - discountAmount).toFixed(2);
      this.totaldicPrice1 = baseTotal.toFixed(2);
      this.longdis = discount;

      // Optional: discounted per-night
      this.pfDisprice = discount > 0 ? (adjustedNightlyPrice * (1 - discount / 100)).toFixed(2) : (this.property.discountedPrice || 0);
      this.pffDisprice = this.pfDisprice;
    },
    childIncrement() {
      this.childQuantity++;
    },
    childDecrement() {
      if (this.childQuantity > 0) {
        this.childQuantity--;
      }
    },
    petIncrement() {
      this.petQuantity++;
    },
    petDecrement() {
      if (this.petQuantity > 0) {
        this.petQuantity--;
      }
    },
    formatTime(time) {
      const [hours, minutes] = time.split(':').map(Number);
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
      const formattedHours = date.getHours() % 12 || 12;
      const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
      return `${formattedHours}:${formattedMinutes} ${ampm}`;
    },
    validateOfferPrice() {
      this.offerPriceError = [];
      this.invalidOfferPrice = false;

      // No valid dates → block input + show friendly message
      if (!this.dateRange.startDate || !this.dateRange.endDate || this.totalPrice1 <= 0) {
        this.offerPriceError = [this.$t('Propertis.select_dates_first')];
        this.invalidOfferPrice = true;
        // Auto-clear offer price when dates are invalid
        if (this.offeredPrice !== null && this.offeredPrice !== '') {
          this.offeredPrice = null;  // This clears the input field
        }
        return false;
      }
      // No offer price entered
      if (!this.offeredPrice || this.offeredPrice <= 0) {
        this.offerPriceError = [this.$t('Propertis.offer_price_required')];
        this.invalidOfferPrice = true;
        return false;
      }
      // Offer out of valid range
      const min = this.minOfferPrice;
      const max = this.totalPrice1;
      if (this.offeredPrice < min || this.offeredPrice > max) {
        this.offerPriceError = [
          this.$t('Propertis.offer_range_hint', {
            min: this.minOfferPriceFormatted,
            max: this.totalPrice1Formatted
          })
        ];
        this.invalidOfferPrice = true;
        return false;
      }

      // All good
      this.offerPriceError = [];
      this.invalidOfferPrice = false;
      return true;
    },
    checkIfUserHasMadeOffer(propertyId) {
      API.getUserOfferStatus({ property_id: propertyId }, (data) => {
        this.userHasMadeOffer = data.hasOffer;
      }, (err) => {
        console.error('Error details:', err);
      });
    },
    submitOffer() {
      if (!this.validateOfferPrice()) {
        return;
      }
      const propertyID = sessionStorage.getItem('propertyId');
      let startDate = moment(this.dateRange.startDate);
      let formattedstartDate = startDate.format('YYYY-MM-DD');
      let endDate = moment(this.dateRange.endDate);
      let formattedendDate = endDate.format('YYYY-MM-DD');
      let no_of_days = endDate.diff(startDate, 'days');
      const minDaystoStay = this.property.min_night_stay || 1;
      const maxDaystoStay = this.property.max_night_stay || 365;
      const differenceInDays = endDate.diff(startDate, 'days');
      this.differenceInDays = differenceInDays;
      if (differenceInDays < minDaystoStay || differenceInDays > maxDaystoStay) {
        let stayError = differenceInDays < minDaystoStay
          ? this.$t('validations.min_stay', { days: minDaystoStay })
          : this.$t('validations.max_stay', { days: maxDaystoStay });
        Swal.fire({
          type: 'error',
          title: this.$t('alerts.error'),
          text: stayError,
          confirmButtonText: this.$t('sweetalert.OK'),
          icon: 'error',
        });
        return;
      }
      const offerData = {
        property_id: propertyID,
        offer_price: this.offeredPrice,
        original_price: this.totalPrice1,
        no_of_days: no_of_days,
        no_of_guests: this.property.max_guests,
        start_date: formattedstartDate,
        end_date: formattedendDate,
        currency: this.currency,
      };
      this.isLoading = true;
      API.submitOffer(offerData, (res) => {
        if (res.status === 200) {
          Swal.fire({
            title: this.$t('sweetalert.offer_submitted'),
            text: this.$t('sweetalert.offer_sent_to_owner') || 'Your offer has been sent to the property owner.',
            icon: 'success',
            type: 'success',
            confirmButtonText: this.$t('sweetalert.OK'),
          });
          this.isLoading = false;
          this.checkIfUserHasMadeOffer(propertyID);
          this.resetOfferForm();
          this.$refs['shared-modal'].hide();
        } else {
          this.isLoading = false;
          if (res.data.errors && res.data.errors.offer_price) {
            this.offerPriceError = res.data.errors.offer_price;
          } else {
            this.offerPriceError = ['An unexpected error occurred. Please try again later.'];
          }
          Swal.fire({
            title: this.$t('alerts.error'),
            text: res.data.message || 'There was an error processing your offer.',
            icon: 'error',
            type: 'error',
            confirmButtonText: 'OK',
          });
        }
      }, (err) => {
        this.isLoading = false;
        if (err.errors && err.errors.offer_price) {
          this.offerPriceError = err.errors.offer_price;
        } else {
          const errorMessage = err.errors?.message || 'An unexpected error occurred. Please try again later.';
          Swal.fire({
            title: this.$t('alerts.error'),
            text: errorMessage,
            icon: 'error',
            type: 'error',
            confirmButtonText: 'OK',
          });
        }
      });
    },
    resetOfferForm() {
      this.offeredPrice = null;
      this.$refs['shared-modal'].hide();
    },
    fetchCurrency() {
      this.currency= 'AED'; // default to AED while fetching
      this.loading = false;
      // let cur = localStorage.getItem('currency');
      // if (cur) {
      //   this.currency = cur;
      //   setTimeout(() => {
      //     this.covertcurency(this.pprice.price, this.pprice.currency, this.currency, this.pprice.discountedPrice, this.pprice.price_per_month);
      //     this.loading = false;
      //   }, 5000);
      // } else {
      //   axios.get('https://ipapi.co/currency/')
      //     .then((response) => {
      //       this.currency = response.data;
      //       setTimeout(() => {
      //         this.covertcurency(this.pprice.price, this.pprice.currency, this.currency, this.pprice.discountedPrice, this.pprice.price_per_month);
      //       }, 2000);
      //     })
      //     .catch((error) => {
      //       this.currency = 'USD';
      //       setTimeout(() => {
      //         this.covertcurency(this.pprice.price, this.pprice.currency, 'USD', this.pprice.discountedPrice, this.pprice.price_per_month);
      //       }, 2000);
      //     });
      // }
    },

    async covertcurency(price, currency, ipCurrency, dCurrency, price_per_month) {
      // Always show USD, no conversions
      this.pfprice = parseFloat(price || 0).toFixed(2);
      this.pffprice = this.pfprice;
      this.pfDisprice = parseFloat(dCurrency || 0).toFixed(2);
      this.pffDisprice = this.pfDisprice;

      if (price_per_month) {
        const cleanPricePerMonth = parseFloat(price_per_month.toString().replace(/,/g, '')) || 0;
        this.property.price_per_month = cleanPricePerMonth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    // will convert currency based on user's IP but currently set to always show USD, can be re-enabled if needed 
    // async covertcurency(price, currency, ipCurrency, dCurrency, price_per_month) {
    //   try {
    //     const response = await fetch(`https://api.exchangerate-api.com/v4/latest/${currency}`);
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     const data = await response.json();
    //     const iprate = data.rates[ipCurrency];
    //     if (dCurrency) {
    //       let converteddPrice = iprate * dCurrency;
    //       let formatteddPrice = converteddPrice.toFixed(2);
    //       this.pfDisprice = formatteddPrice;
    //       this.pffDisprice = formatteddPrice;
    //     }
    //     let convertedPrice = iprate * price;
    //     let formattedPrice = convertedPrice.toFixed(2);
    //     this.pfprice = formattedPrice;
    //     this.pffprice = formattedPrice;
    //     let cleanPricePerMonth = parseFloat(price_per_month.toString().replace(/,/g, ''));
    //     let convertedMPrice = iprate * cleanPricePerMonth;
    //     let formattedMPrice = convertedMPrice.toLocaleString();
    //     this.property.price_per_month = formattedMPrice;
    //   } catch (error) {
    //     console.error('Error fetching currency:', error);
    //     this.pfprice = price || 0;
    //     this.pffprice = price || 0;
    //     this.pfDisprice = dCurrency || 0;
    //     this.pffDisprice = dCurrency || 0;
    //     this.property.price_per_month = price_per_month ? parseFloat(price_per_month.toString().replace(/,/g, '')).toLocaleString() : '0';
    //   }
    // },
    changeLanguage(language) {
      Vue.prototype.$EventBus.$emit('changeLanguage', language);
      this.selectedLanguage = language;
    },
    getReviewFeedback(averageRating) {
      if (averageRating >= 4.5) {
        return 'Outstanding';
      } else if (averageRating >= 3.5) {
        return 'Good';
      } else if (averageRating >= 2.5) {
        return 'Average';
      } else if (averageRating >= 1.5) {
        return 'Below Average';
      } else {
        return 'Poor';
      }
    },
    getImagePath() {
      if (this.property.photos && this.property.photos.length > 0) {
        return this.property.photos[0].path;
      }
      return '';
    },
    validateForm() {
      this.formErrors = {
        message: '',
      };
      let isValid = true;
      if (!this.form.message) {
        this.formErrors.message = 'Message is required.';
        isValid = false;
      }
      return isValid;
    },
    validateTextForm() {
      this.textFormErrors = {
        message: '',
      };
      let isValid = true;
      if (!this.textForm.message) {
        this.textFormErrors.message = 'Message is required.';
        isValid = false;
      }
      if (!this.isLogedin) {
        this.textFormErrors.message = 'Please Login For The Live Chat.';
        isValid = false;
      }
      return isValid;
    },
    messages() {
      this.$router.push({ name: 'chat', query: { conversationId: this.conversation_id } });
    },
    handleSubmit() {
      const propertyID = sessionStorage.getItem('propertyId');
      this.form.property_id = propertyID;
      if (this.validateForm()) {
        API.sendMailToPropertyOwner(
          this.form,
          (data) => {
            if (data.status == 200) {
              this.$swal({
                icon: 'success',
                type: 'success',
                title: 'Success',
                text: data.message,
              });
            } else {
              this.$swal({
                icon: 'error',
                type: 'error',
                title: 'Oops...',
                text: data.message,
              });
            }
            this.isDisabled = false;
          },
          (err) => {
            this.isDisabled = false;
            this.$swal({
              icon: 'error',
              type: 'error',
              title: 'Oops...',
              text: err.message,
            });
          }
        );
      }
    },
    handleSendMessage() {
      if (!this.validateTextForm()) return;
      this.isSending = true;
      const data = {
        user_id: this.property.user_id,
      };
      API.createOrGetConversation(
        data,
        (response) => {
          const conversationId = response.conversation.id;
          this.conversation_id = conversationId;
          const messageData = {
            content: this.textForm.message,
          };
          API.sendMessage(
            conversationId,
            messageData,
            () => {
              this.textForm.message = '';
              this.messageSent = true;
              this.errorMessage = '';
              this.isSending = false;
            },
            () => {
              this.errorMessage = 'Something went wrong. Please try again.';
              this.isSending = false;
            }
          );
        },
        () => {
          this.errorMessage = 'Something went wrong. Please try again.';
          this.isSending = false;
        }
      );
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    updateTranslations() {
      // Base structure
      this.locale_data = {
        direction: 'ltr',
        separator: ' - ',
        applyLabel: this.$t('pagination.apply'),
        cancelLabel: this.$t('pagination.cancel'),
        weekLabel: this.$t('date.week_abbr'),
        customRangeLabel: this.$t('date.custom_range'),
        firstDay: 1,
        // Translated days (short abbreviations)
        daysOfWeek: [
          this.$t('date.days.sunday_short'),
          this.$t('date.days.monday_short'),
          this.$t('date.days.tuesday_short'),
          this.$t('date.days.wednesday_short'),
          this.$t('date.days.thursday_short'),
          this.$t('date.days.friday_short'),
          this.$t('date.days.saturday_short')
        ],

        // Translated full month names
        monthNames: [
          this.$t('date.months.january'),
          this.$t('date.months.february'),
          this.$t('date.months.march'),
          this.$t('date.months.april'),
          this.$t('date.months.may'),
          this.$t('date.months.june'),
          this.$t('date.months.july'),
          this.$t('date.months.august'),
          this.$t('date.months.september'),
          this.$t('date.months.october'),
          this.$t('date.months.november'),
          this.$t('date.months.december')
        ]
      };
    },
    onLanguageChanged(language) {
      this.currentLanguage = language === 'en' ? '' : `_${language}`;
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = this.disabledDates.some((disabledDate) =>
          date.setHours(0, 0, 0, 0) === disabledDate.setHours(0, 0, 0, 0)
        );
      }
      return classes;
    },
    checkDateOverlap(newStartDate, newEndDate) {
      for (const booking of this.disabledDates) {
        const existingStartDate = moment(booking);
        if (
          newStartDate.isBetween(existingStartDate, existingStartDate, undefined, '[]') ||
          newEndDate.isBetween(existingStartDate, existingStartDate, undefined, '[]') ||
          existingStartDate.isBetween(newStartDate, newEndDate, undefined, '[]')
        ) {
          return true;
        }
      }
      return false;
    },
    getBookingsByPropertyID(propertyId) {
      API.getBookingsByPropertyID(propertyId, (res) => {
        const bookings = res.data.data;
        this.disabledDates = [];
        bookings.forEach((booking) => {
          const startDate = new Date(booking.start_date);
          const endDate = new Date(booking.end_date);
          const datesInRange = this.getDatesInRange(startDate, endDate);
          this.disabledDates = this.disabledDates.concat(datesInRange);
        });
      }, (err) => {
        console.error('Error fetching bookings:', err);
      });
    },
    getDatesInRange(startDate, endDate) {
      const datesInRange = [];
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        datesInRange.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return datesInRange;
    },
    getProperty(propertyId) {
      const originalUrl = this.$route.fullPath;

      API.getProperty(propertyId, (res) => {
        this.property = res.data.data;
        const today = new Date();
        const defaultEndDate = new Date(today);
        defaultEndDate.setDate(
          today.getDate() + (parseInt(this.property.min_night_stay || 1, 10))
        );

        this.dateRange = {
          startDate: today,
          endDate: defaultEndDate,
        };

        this.sdate = moment(today).format('DD-MM-YYYY');
        this.edate = moment(defaultEndDate).format('DD-MM-YYYY');

        if (this.$refs.datePickerRef?.picker) {
          this.$refs.datePickerRef.picker.setStartDate(today);
          this.$refs.datePickerRef.picker.setEndDate(defaultEndDate);
        }
        // SET THE AVATAR HERE
        this.propertyOwnerAvatar = res.data.data.user?.avatar
        ? "/" + res.data.data.user.avatar
        : "http://bootdey.com/img/Content/avatar/avatar1.png";
        if (this.property.price_per_month) {
          let monthlyPrice = parseFloat(this.property.price_per_month.replace(/,/g, ''));
          this.property.price = monthlyPrice / 30;
          this.pfprice = (monthlyPrice / 30).toFixed(2);
          this.pffprice = this.pfprice;
        } else {
          this.pfprice = this.property.price || 0;
          this.pffprice = this.pfprice.toFixed(2);
        }
        this.discount = res.data.discounts || {};
        this.flashDiscount = res.data.flashdiscount || {};
        this.address = `${this.property.city} ${this.property.state} ${this.property.country}`;
        this.orginalguest = this.property.max_guests;
        this.pfDisprice = this.property.discountedPrice || 0;
        this.pffDisprice = this.pfDisprice;
        this.targetDate = this.flashDiscount?.start_date || this.property.discountedate || '';
        const loader = new Loader({
          apiKey: process.env.VUE_APP_GOOLE_PLACES_API_KEY,
          version: 'weekly',
          libraries: ['places'],
          language: 'en',
        });
        loader.load().then(() => {
          const geocoder = new window.google.maps.Geocoder();
          const initMap = (mapRef, mapVar) => {
            if (mapRef && !mapVar) {
              mapVar = new window.google.maps.Map(mapRef, {
                center: { lat: 0, lng: 0 },
                zoom: 8,
              });
              geocoder.geocode({ address: this.address }, (results, status) => {
                if (status === 'OK') {
                  mapVar.setCenter(results[0].geometry.location);
                  new window.google.maps.Marker({
                    map: mapVar,
                    position: results[0].geometry.location,
                  });
                } else {
                  console.error('Geocode failed: ' + status);
                }
              });
            }
            return mapVar;
          };

          // Init both maps
          this.exploreMap = initMap(this.$refs.exploreMap, this.exploreMap);
          this.map = initMap(this.$refs.map, this.map);
        });
        res.data.checkPayment.forEach((value) => {
          if (propertyId == value.propertyId) {
            this.booked = true;
          }
        });
        if (this.targetDate) {
          if (this.targetDate.includes(':')) {
            const dateTimeParts = this.targetDate.split(' ');
            const dateParts = dateTimeParts[0].split('-');
            const timeParts = dateTimeParts[1].split(':');
            let targetDateObj = new Date(
              dateParts[0],
              dateParts[1] - 1,
              dateParts[2],
              timeParts[0],
              timeParts[1],
              timeParts[2]
            );
            targetDateObj.setDate(targetDateObj.getDate() + 1);
            this.targetTime = targetDateObj.getTime();
          } else {
            const dateParts = this.targetDate.split('-');
            let targetDateObj = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
            targetDateObj.setDate(targetDateObj.getDate() + 1);
            this.targetTime = targetDateObj.getTime();
          }
          this.updateCountdown();
          this.timer = setInterval(this.updateCountdown, 1000);
        }
        this.fetchCurrency();
      }, (err) => {
        if (err.response?.data?.message === 'Unauthenticated.') {
          localStorage.setItem('originalUrl', this.$route.fullPath);
          this.$router.push({ name: 'guest_login' });
        } else {
          console.error('Error fetching property:', err);
        }
      });
    },
    getRatingAndReviews(propertyId) {
      let sum = 0;
      let count = 0;
      API.getRatingAndReviews(propertyId, (res) => {
        res.data.forEach((value) => {
          if (!isNaN(value.rating)) {
            sum += parseInt(value.rating);
            count++;
          }
        });
        this.reviews = count;
        this.rating = count > 0 ? sum / count : 0;
      }, (err) => {
        console.error('Error fetching ratings:', err);
      });
    },
    setRating(value) {
      this.rating = value;
    },
    changeActive(index) {
      this.activeIndex = index;
    },
    redirectToPayment() {
      if (!localStorage.getItem('isLoggedin')) {
        this.$bvModal.show('modal-4');
        return;
      }
      const minDaystoStay = this.property.min_night_stay || 1;
      const maxDaystoStay = this.property.max_night_stay || 365;
      let startDate = moment(this.dateRange.startDate);
      let endDate = moment(this.dateRange.endDate);
      const differenceInDays = endDate.diff(startDate, 'days');
      if (differenceInDays < minDaystoStay || differenceInDays > maxDaystoStay) {
        let stayError = differenceInDays < minDaystoStay
          ? this.$t('validations.min_stay', { days: minDaystoStay })
          : this.$t('validations.max_stay', { days: maxDaystoStay });
        Swal.fire({
          type: 'error',
          title: this.$t('alerts.error'),
          text: stayError,
          confirmButtonText: this.$t('sweetalert.OK'),
          icon: 'error',
        });
        return;
      }
      this.differenceInDays = differenceInDays;
      if (!this.dateRange.startDate || !this.dateRange.endDate || this.dateRange.startDate.getTime() === this.dateRange.endDate.getTime()) {
        alert('Please Select Available Dates.');
        return;
      }
      if (this.checkDateOverlap(startDate, endDate)) {
        Swal.fire({
          type: 'error',
          title: this.$t('alerts.error'),
          text: this.$t('sweetalert.overlap'),
          confirmButtonText: this.$t('sweetalert.OK'),
          icon: 'error',
        });
        return;
      }
      let formattedstartDate = startDate.format('YYYY-MM-DD');
      let formattedendDate = endDate.format('YYYY-MM-DD');
      this.$router.push({
        name: 'property_payment',
        params: {
          guestnumber: this.property.max_guests,
          prefund: this.prefund,
          nrefund: this.nrefund,
          parrefund: this.parrefund,
          days: differenceInDays,
          totalPrice1: parseFloat(this.totalPrice1 || this.pfprice || 0).toFixed(2),
          // pfprice: parseFloat(this.pfprice || this.property.price || 0).toFixed(2),
          pfprice: parseFloat(this.pfprice).toFixed(2),
          currency: this.currency,
          totalPrice: parseFloat(this.totalPrice1 || this.pfprice || 0).toFixed(2),
          startDate: formattedstartDate,
          endDate: formattedendDate,
          minDaystoStay: minDaystoStay,
          maxDaystoStay: maxDaystoStay,
          discountAmount: parseFloat(this.discountAmount || 0).toFixed(2),
          totaldicPrice1: parseFloat(this.totaldicPrice1 || 0).toFixed(2),
          pfDisprice: this.pfDisprice || 0,
          longdis: this.longdis || null,
          offer_id: this.selectedOfferId || null,
          discount_object: JSON.stringify(this.discount),
        },
      });
    },
    redirectToRating() {
      this.$router.push({ name: 'property_rating' });
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
  created() {
    if (this.$route.params.id) {
      sessionStorage.setItem('propertyId', this.$route.params.id);
    }
  },
  beforeDestroy() {
    Vue.prototype.$EventBus.$off('clear-dates');
    Vue.prototype.$EventBus.$off('changeLanguage', this.onLanguageChanged);
    clearInterval(this.timer);
    document.removeEventListener('click', this.handleClickOutside);
    this.$root.$off('currency-changed');
  },
};
</script>
<style>
.vue-tabslist.sticky .tabs .card-header {
  position: fixed !important;
  top: 62px;
  left: 50%;
  z-index: 995;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  transform: translate(-50%, 0);
  padding: 10px !important;
}

.vue-tabslist.sticky .tabs .card-header .card-header-tabs {
  border-radius: 30px;
  border: 1px solid #e3e3e3;
  margin-bottom: 0px;
  row-gap: 0;
}

.vue-tabslist.sticky .tabs .card-header .card-header-tabs .nav-item .nav-link {
  padding: 6px 6px;
}

.vue-tabslist.sticky .card-header .card-header-tabs .nav-item:last-child,
.vue-tabslist.sticky .card-header .card-header-tabs .nav-item:last-child a {
  border-bottom-left-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
}

.vue-tabslist.sticky .tabs .tab-content {
  padding-top: 260px !important;
}

/* Optional: smooth transition */
.vue-tabslist {
  transition: all 0.2s ease;
}

/* Mobile-only sticky behavior */
@media (min-width: 581px) {
  .vue-tabslist.sticky {
    position: static !important;
    box-shadow: none;
  }

  .vue-tabslist.sticky+.card>.tab-content {
    margin-top: 0 !important;
  }
}

.my-offer-tabs .table-responsive tr td:first-child {
  width: auto;
  min-width: auto;
}
</style>
<style scoped>
/*****************globals*************/
.container-fluid.page-body-wrapper.client-dashbboard {
  padding-top: 75px !important;
}

body {
  font-family: 'open sans';
  overflow-x: hidden;
}

img {
  max-width: 100%;
}

.date-picker .vue-daterange-picker {
  width: 100%;
}

.payment-form {
  margin-bottom: 15px;
}

.remove-border input:placeholder-shown {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #000;
  padding: 14px 17px;
  height: 44px;
}

.reportrange-text {
  background: #fff;
  cursor: pointer;
  padding: 10px 10px;
  border: 1px solid #000;
  overflow: hidden;
  height: auto;
  max-width: 220px;
  color: #000;
  width: 100%;
}

.preview {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.product-detail-sec {
  width: 100%;
}

.pricing-detail-box {
  border: 1px solid #dfe0e4;
  padding: 1.5rem;
  margin: .75rem;
  border-radius: 20px;
  position: sticky;
  top: 30px;
  z-index: 1;
}

.product-detail-sec .col-md-4 {
  position: relative;
}

.pricing-detail-box .heading {
  display: flex;
  align-items: flex-end;
  gap: .5rem;
  padding-right: 22px;
}

.pricing-detail-box .heading h2 {
  margin: 0;
  color: #191e3b;
  font-size: 1.50rem;
  font-weight: 500;
  line-height: 2rem;
}

.pricing-detail-box .heading span {
  font-size: 20px;
  line-height: 1.125rem;
  min-inline-size: calc(4px + 1.125rem);
}

.date-pricing {
  display: flex;
  align-items: center;
  margin-top: .75rem;
  padding-top: 1.2rem;
  border-top: 1px solid #dfe0e4;
  padding-bottom: 1.2rem;
}

.date-pricing svg {
  width: 18px;
  height: 18px;
  margin-right: .5rem;
}

.date-pricing span {
  font-size: .875rem;
  line-height: 1.125rem;
  min-inline-size: calc(4px + 1.125rem);
}

.rating-counter {
  padding-left: 4px;
  padding-right: 4px;
  background-color: #e2ebfa;
  border-radius: 5px;
  font-weight: 600;
  color: #000;
}

.form-section {
  padding: 0.7rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.form-section .form-field {
  width: 48%;
}

.form-section .form-field:last-child {
  width: 100%;
}

.form-section .form-field .form-control {
  height: 48px;
  border: 1px solid #000;
  border-radius: 8px;
  color: #000;
}

.form-control {
  display: block;
  width: 100%;
  height: 46px;
  padding: 5px 15px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5rem;
  color: #333;
  background-color: #fff;
  background-image: none;
  border: 1px solid #676A7D;
  border-radius: 30px;
  box-shadow: none;
  outline: none;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

textarea.form-control {
  height: 110px;
  padding: 15px;
}

.share-buttons {
  display: flex;
  justify-content: center;
}

.share-buttons .share-icons {
  width: 30px;
  height: 30px;
  border: 1px solid #676A7D;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 100px;
  color: #000000;
  background: #fff;
  cursor: pointer;
}

.share-buttons .share-icons svg {
  width: 15px;
  height: 15px;
}

.share-buttons .share-icons:hover {
  background: #70d3ff;
  color: #fff;
  border-color: #70d3ff;
}

.share-buttons .share-icons:hover svg {
  fill: #fff;
}

.product-detail-sec h2 {
  font-size: 25px;
  font-weight: 500;
  line-height: 1.2;
}

.product-detail-sec ul {
  padding: 0;
  margin: 0;
}

.product-detail-sec p,
.product-detail-sec span {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  min-inline-size: calc(4px + 1.125rem);
}

.product-detail-sec .long_stay_dis .long_dis p {
  font-size: 15px;
  margin-left: 5px;
}

.product-detail-sec .long_stay_dis .long_dis p span.checked-span {
  border-bottom: 0;
  width: auto;
  font-size: 12px;
  background: #70d3ff;
  padding: 4px 12px;
  color: #fff;
  position: unset;
  border-radius: 100px;
  height: 32px;
}

.product-detail-sec .long_stay_dis .long_dis h5,
.product-detail-sec .long_stay_dis .long_dis p {
  margin-bottom: 0px;
}

.product-detail-sec h3 {
  font-size: 1.45rem;
  font-weight: 500;
  line-height: 1.5rem;
}

.pricing-anchor {
  padding: .75rem;
}

.pricing-anchor a {
  font-size: .875rem;
  line-height: 1.125rem;
  text-decoration: underline;
}

.form-btn .availbility-btn {
  font-size: 1rem;
  line-height: 1.25rem;
  min-block-size: 2.25rem;
  padding: 14px 20px;
  background: #70d3ff;
  color: #fff;
  border: 1px solid #70d3ff;
  width: 100%;
  gap: .5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2500rem;
}

.make-another-offer-btn {
  font-size: 1rem;
  line-height: 1.25rem;
  min-block-size: 2.25rem;
  padding: .25rem 1rem;
  background: #70d3ff;
  color: #fff;
  border: 1px solid #70d3ff;
  /* width: 100%; */
  float: right;
  gap: .5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2500rem;
}

.form-btn .availbility-btn:hover {
  color: #70d3ff;
  background: #fff;
}

.make-another-offer-btn:hover {
  color: #70d3ff;
  background: #fff;
}

.location-list ul li {
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}

.location-list ul li span:nth-child(2) {
  margin-right: auto;
}

.location-list ul li span i {
  font-size: 1.2rem;
}

.popular-amenities,
.explore-area,
.spaces-detail,
.about-property {
  /* margin-bottom: 2.5rem; */
  margin-bottom: 20px;
}

.map-sec {
  border: 1px solid #dfe0e4;
  border-radius: 15px;
}

.rooms-and-bed h2 {
  margin-bottom: 30px;
}

.rooms-and-bed .room-bed-detail {
  border-bottom: 1px solid #dfe0e4;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}

.rooms-and-bed .room-bed-detail h3 {
  margin-bottom: 15px;
}

.rooms-and-bed .room-bed-detail ul {
  display: flex;
  justify-content: space-between;
}

.rooms-and-bed .room-bed-detail ul li {
  width: 50%;
}

.rooms-and-bed .room-bed-detail ul li h3 {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.25rem;
  margin-bottom: 0;
}

.spaces-detail h2,
.about-property h2 {
  margin-bottom: 30px;
}

.space-anchor a {
  font-size: .875rem;
  gap: .25rem;
  line-height: 1.125rem;
  display: flex;
}

.about-property p {
  font-size: .875rem;
  line-height: 1.125rem;
  margin: 0 0 3px;
}

.about-property .about-details {
  margin-bottom: 20px;
}

.about-property .about-details h3 {
  margin-bottom: 10px;
}

.about-property .about-details .image {
  margin-bottom: 12px;
}

.about-property .about-details .image img {
  max-width: 40px;
}

.two-column .accordion button {
  background: #fff !important;
  border: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  color: #191e3b !important;
}

@media screen and (max-width: 996px) {
  .preview {
    margin-bottom: 20px;
  }
}

.preview-pic {
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.preview-thumbnail.nav-tabs {
  border: none;
  margin-top: 15px;
}

.preview-thumbnail.nav-tabs li {
  width: 18%;
  margin-right: 2.5%;
}

.preview-thumbnail.nav-tabs li img {
  max-width: 100%;
  display: block;
}

.preview-thumbnail.nav-tabs li a {
  padding: 0;
  margin: 0;
}

.preview-thumbnail.nav-tabs li:last-of-type {
  margin-right: 0;
}

.tab-content {
  overflow: hidden;
}

.tab-content img {
  width: 100%;
  -webkit-animation-name: opacity;
  animation-name: opacity;
  -webkit-animation-duration: .3s;
  animation-duration: .3s;
}

.vue-tabslist .tab-content img {
  animation: none;
}

.send-message button.btn.btn-primary {
  font-size: 16px !important;
  line-height: 1.25rem;
  min-block-size: 2.25rem;
  padding: .25rem 1rem;
  background: #70d3ff !important;
  color: #fff;
  border: 1px solid #70d3ff;
  width: 100%;
  gap: .5rem;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 30px !important;
}

.send-message button.btn.btn-primary:hover {
  background: #fff !important;
}

.card {
  line-height: 1.5em;
  border: 0;
}

.tabs-list {
  width: 100%;
}

/* .details.details-section {
  padding: 1.5rem;
} */

.preview .row.thumbnail-holder.m-0 {
  gap: 2px;
  flex-wrap: nowrap;
}

.thumbnail-holder .col-lg-6 .thumbnail-img {
  height: 394px;
}

.thumbnail-holder .col-lg-3 .thumbnail-img {
  height: 196px;
}

.preview .thumbnail-img {
  padding-bottom: 2px;
  overflow: hidden;
  background: #f6f6f6;
}

.preview .thumbnail-img a {
  display: block;
  width: 100%;
  height: 100%;
}

.preview .thumbnail-img img.property-gallery-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
}

.preview .col-lg-3.p-0 .thumbnail-img {
  height: 50%;
}

.mobile-property-carousel-container {
  width: 100% !important;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  background: #000;
}

#carousel-mobile,
#carousel-mobile .carousel-inner,
#carousel-mobile .carousel-item {
  width: 100% !important;
  min-width: 100% !important;
  display: block !important;
}

#carousel-mobile .mobile-gallery-link {
  display: block !important;
  width: 100% !important;
  height: 100% !important;
}

#carousel-mobile img.mobile-property-detail-img {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 280px !important;
  object-fit: cover !important;
  object-position: center !important;
  display: block !important;
  border-radius: 12px;
}

@media (max-width: 576px) {
  #carousel-mobile img.mobile-property-detail-img {
    height: 250px !important;
  }
}

#carousel-mobile .carousel-indicators {
  display: none !important;
}

#carousel-mobile .carousel-control-prev,
#carousel-mobile .carousel-control-next {
  width: 34px;
  height: 34px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  margin: 0 8px;
}

.mobile-photo-badge {
  position: absolute;
  bottom: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.75);
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 600;
  z-index: 5;
  pointer-events: none;
  backdrop-filter: blur(4px);
}

.popular-amenities h3,
.content-list h3 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5rem;
  color: #191e3b;
  margin-bottom: .75rem;
}

.content-list ul {
  padding: 0;
  margin: 0;
}

.content-list ul li {
  position: relative;
  padding-left: 15px;
}

.content-list ul li:after {
  width: 5px;
  height: 5px;
  background: #000;
  position: absolute;
  content: '';
  left: 0;
  top: 50%;
  display: block;
  border-radius: 100px;
  transform: translateY(-50%);
}

.popular-amenities ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}

.popular-amenities ul li {
  width: 50%;
}

.popular-amenities ul.important-information-list li {
  width: 90%;
  color: #191e3b;
  font-size: 1.075rem;
  font-weight: 400;
  line-height: 1.125rem;
}

.popular-amenities.important-information ul li {
  width: 70%;
}

.air-condition {
  font-size: .875rem;
  line-height: 1.125rem;
  min-inline-size: calc(4px + 1.125rem);
  display: flex;
  align-items: center;
  padding-bottom: .75rem;
}

.air-condition span {
  padding-right: 15px;
}

.air-condition span i {
  /* font-size: 20px; */
  font-size: 16px;
}

button.see-all-btn i {
  font-size: 18px;
  line-height: 17px;
}

button.see-all-btn {
  color: #70d3ff !important;
  background: #fff;
  border: 0;
  padding: 0;
  font-size: .875rem;
  gap: .25rem;
  line-height: 1.125rem;
  display: flex;
  align-items: center;
  padding-left: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

@media screen and (min-width: 997px) {
  .wrapper {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
}

.details {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.colors {
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.product-title,
.price,
.sizes,
.colors {
  text-transform: UPPERCASE;
  font-weight: bold;
}

.fa-star.checked {
  font-weight: 600;
}

.checked,
.price span {
  color: #ff9f1a;
}

.product-title,
.rating,
.product-description,
.price,
.vote,
.sizes {
  margin-bottom: 15px;
}

.product-title {
  margin-top: 0;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.2;
}

.size {
  margin-right: 10px;
}

.size:first-of-type {
  margin-left: 40px;
}

.color {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  height: 2em;
  width: 2em;
  border-radius: 2px;
}

.color:first-of-type {
  margin-left: 20px;
}

.add-to-cart,
.like {
  background: #ff9f1a;
  padding: 1.2em 1.5em;
  border: none;
  text-transform: UPPERCASE;
  font-weight: bold;
  color: #fff;
  -webkit-transition: background .3s ease;
  transition: background .3s ease;
}

.add-to-cart:hover,
.like:hover {
  background: #b36800;
  color: #fff;
}

.not-available {
  text-align: center;
  line-height: 2em;
}

.not-available:before {
  font-family: fontawesome;
  content: "\f00d";
  color: #fff;
}

.orange {
  background: #ff9f1a;
}

.green {
  background: #85ad00;
}

.blue {
  background: #0076ad;
}

.tooltip-inner {
  padding: 1.3em;
}

@-webkit-keyframes opacity {
  0% {
    opacity: 0;
    -webkit-transform: scale(3);
    transform: scale(3);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes opacity {
  0% {
    opacity: 0;
    -webkit-transform: scale(3);
    transform: scale(3);
  }

  100% {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.progressbar {
  counter-reset: step;
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}

.progressbar li {
  float: left;
  width: 24.28%;
  position: relative;
  text-align: center;
  color: #191e3b;
  font-size: .875rem;
  font-weight: 400;
  line-height: 1.125rem;
}

.product-detail-sec .paragrapgh p,
.product-detail-sec .paragrapgh span {
  color: #191e3b;
  font-size: 1.075rem;
  font-weight: 400;
  line-height: 1.125rem;
}

.progressbar li i {
  display: block;
  margin: 4px auto 5px auto;
  color: #191e3b;
  /* Default icon color */
}

.progressbar li:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background: green;
  top: 10px;
  left: -50%;
  z-index: 0;
}

.progressbar li:nth-child(3):after {
  background: gray;
  content: '';
}

.progressbar li:nth-child(2) .fa-circle {
  color: gray;
}

.progressbar li:last-child:after {
  background: red;
}

.progressbar li:last-child .fa-times:before {
  border: 1px solid red;
  background: #fff;
}

.progressbar li.active i {
  color: green;
}

.progressbar li.active:nth-last-child(-n+2) i {
  color: red;
}

.progressbar li.active:after {
  background: #3aac5d;
}

.progressbar li:first-child:after {
  content: none;
}

.cancelbar {
  margin-bottom: 25px;
  border-radius: 21px;
  background: #fff;
  padding-left: 10px;
  padding-top: 10px;
}

.cancelbar .cancelbar-list {
  width: 100%;
  max-width: 75%;
  margin-left: 11%;
}

.cancelbar .cancelbar-list .column {
  width: 33.33%;
  text-align: center;
}

.fa-check:before {
  border: 1px solid black;
  padding: 5px;
  border-radius: 100px;
  color: green;
  background: #f7f7f8;
  position: relative;
  z-index: 9;
}

.fa-times:before {
  border: 2px solid red;
  border-radius: 100px;
  color: transparent;
  background: red;
  position: relative;
  z-index: 9;
  width: 12px;
  height: 12px;
  display: inline-block;
}

.fa-minus:before {
  border: 1px solid black;
  padding: 5px 7px;
  border-radius: 100px;
  color: grey;
  background: #f7f7f8;
  position: relative;
  z-index: 9;

}

.fa-circle:before {
  padding: 0;
  border-radius: 100px;
  background-color: #f7f7f8;
  font-size: 14px;
  position: relative;
  z-index: 9;
}

.accordian-guests {
  position: relative;
}

.form-group label {
  font-size: 16px;
  margin: 0;
}

.popup-guest {
  border: 1px solid rgb(231 231 232);
  border-radius: .5rem;
  background: white;
  box-shadow: 0 3px 12px 0 rgb(0 0 0 / 38%);
  display: block;
  max-width: 100%;
  margin-left: auto;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  position: absolute;
  border-radius: 32px;
  z-index: 9;
}

.guest-content {
  display: flex;
  align-items: center;
  border-right: 0 !important;
  justify-content: space-between;
  width: 100%;
}

.guest-content .guest-col h4 {
  margin: 0;
  font-weight: 400;
  font-size: 15px;
  color: #333;
}

.guest-content .guest-col .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group-append,
.input-group-prepend {
  background: #ffffff;
  color: #c9c8c8;
  width: auto;
  border: none;
}

.input-group-prepend {
  margin-right: -1px;
}

.guest-content .form-control {
  padding: 0;
  height: 30px;
  border: 0;
  text-align: center;
  width: 60px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.center-tabs-layout .tabs-content p,
.guest-content .form-control {
  color: #000;
  font-weight: 400;
  font-size: 16px;
  margin: 0;
}

.guest-content .form-control::-webkit-outer-spin-button,
.guest-content .form-control::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
<style scoped>
.date-picker-container {
  display: flex;
  gap: 10px;
}

.date-picker-container .datepicker {
  flex: 1;
}

.strikethrough {
  text-decoration: line-through;
}

.favorite-button-discount.timer {
  position: absolute;
  top: 81px;
  bottom: inherit;
  right: 10px;
  margin: 0 30px;
}

.flex-pricing-detail-box .timer {
  position: static;
  text-align: center;
  margin: 0;
}

.flex-pricing-detail-box .timer.favorite-button-discount {
  position: absolute;
  top: 63px;
  bottom: inherit;
}

.timer {
  position: absolute;
  top: 42px;
  right: 10px;
  margin: 0 30px;
}

.long_stay_dis {
  border: 1px solid #dfe0e4;
  padding: 1.5rem;
  margin: .75rem;
  border-radius: 20px;
}

.long_stay_dis h4 {
  margin: 0 0 15px;
  color: #191e3b;
  font-size: 1.55rem;
  font-weight: 500;
  line-height: 2rem;
  border-bottom: 1px solid #dfe0e4;
  padding-bottom: 10px;
}

.long_stay_dis .long_dis {
  margin-bottom: 15px;
}

.cancelbar .cancelbar-list .column p {
  margin: 0 !important;
}

.strikethrough {
  position: relative;
}

.favorite-button-discount {
  position: absolute;
  right: 0;
  bottom: -44px;
}

.favorite-button-discount span.checked-span {
  box-shadow: 0 0 0 0;
  border-radius: 100px;
  height: 32px;
  width: 32px;
  border: 0;
  font-size: 12px;
  background: #70d3ff;
  color: #fff;
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

span.checked-span {
  box-shadow: 0 0 0 0;
  border-radius: 100px;
  height: 32px;
  width: 32px;
  border: 0;
  font-size: 12px;
  background: #70d3ff;
  color: #fff;
  position: relative;
  z-index: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

img.loading-gif {
  height: 50px;
  width: 50px;
}

.timeline {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.timeline-item {
  position: relative;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  width: 33.3%;
}

.timeline-item:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: currentColor;
  clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%);
  z-index: 0;
}

.timeline-item:after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 17px 0 17px 13px;
  border-color: transparent transparent transparent #fff;
  transform: rotate(0deg);
}

.full-refund,
.timeline .timeline-item.full-refund .timeline-title {
  color: #4CAF50;
}

.partial-refund,
.timeline .timeline-item.partial-refund .timeline-title {
  color: #9E9E9E;
}

.no-refund,
.timeline .timeline-item.no-refund .timeline-title {
  color: #F44336;
}

.timeline-title {
  position: absolute;
  top: -28px;
  font-size: 14px !important;
  color: #666;
}

.timeline-date {
  position: absolute;
  bottom: -25px;
  right: 0;
  font-size: 12px !important;
  color: #666;
}

.timeline-today .timeline-date {
  left: 10px;
}

.shared-form-fields p.form-control,
.shared-form-fields .guest-content .guest-col h4,
.shared-form-fields .guest-content .form-control {
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  color: #000;
}

#shared-modal .shared-form-fields p.form-control {
  color: #000;
}

.shared-form-fields p.form-control {
  width: 100%;
  border: 1px solid #000000;
  padding: 14px 17px;
  height: 44px;
}

.shared-form-fields .popup-guest {
  z-index: 1;
}

.table-discounts-list.long_stay_dis .long_dis:nth-child(even) {
  background-color: #ebebeb;
}

.table-discounts-list.long_stay_dis .long_dis {
  margin-bottom: 0px;
  padding: 10px 8px;
}

.table-discounts-list.long_stay_dis .long_dis h5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-discounts-list.long_stay_dis .long_dis h5 span {
  font-weight: 500;
}

.col-xl-4.responsive-col {
  margin-top: -130px;
}

@media (max-width: 1199px) {
  .col-xl-4.responsive-col {
    margin-top: -122px;
  }

  .cancelbar .cancelbar-list .column p {
    font-size: 14px;
  }

  .col-lg-4.relative .pricing-detail-box,
  .col-lg-4.relative .long_stay_dis {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 991px) {

  .col-xl-4.responsive-col {
    margin-top: 0px;
  }

  .row.flex-reverse-row {
    flex-direction: column-reverse !important;
  }

  .col-xl-4.responsive-col .table-discounts-list {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .product-title,
  .product-detail-sec h2 {
    font-size: 22px;
    line-height: 1.2;
  }

  .popular-amenities h3,
  .content-list h3,
  .product-detail-sec h3 {
    font-size: 18px;
    line-height: 1.2;
  }

  .product-detail-sec p,
  .product-detail-sec span,
  .form-group label {
    font-size: 16px;
  }

  .popular-amenities,
  .explore-area,
  .spaces-detail,
  .about-property {
    margin-bottom: 20px;
  }

  .pricing-detail-box {
    margin: 0 0 10px;
    /* margin: 0 0 40px; */
  }

  .preview .thumbnail-img {
    height: 100%;
  }

  .preview .thumbnail-img img {
    object-fit: cover;
  }
}

@media (max-width: 767px) {
  .client-dashbboard .main-panel .card {
    padding: 1em 0 0;
  }

  .col-md-8 .popular-amenities {
    margin-bottom: 0;
  }

  .long_stay_dis {
    margin: 0 0 30px;
  }

  .product-title,
  .product-detail-sec h2 {
    font-size: 18px;
    line-height: 1.2;
  }

  .about-details.row.mb-5,
  .two-column.mb-5 {
    margin-bottom: 20px !important;
  }

  .popular-amenities h3,
  .content-list h3,
  .product-detail-sec h3 {
    font-size: 18px;
    line-height: 1.2;
  }

  .details.details-section,
  .long_stay_dis {
    padding: 15px;
  }

  .pricing-detail-box .heading h2,
  .long_stay_dis h4 {
    font-size: 20px;
    line-height: 1.2;
  }

  .shared-form-fields p.form-control {
    padding: 17px 17px;
    height: 52px;
  }
}

@media (max-width: 574px) {
  .preview .row.thumbnail-holder.m-0 {
    flex-wrap: wrap;
  }

  .preview .col-lg-3.p-0 .thumbnail-img {
    height: auto;
  }

  .details.details-section .product-title {
    font-size: 20px;
  }

  /* .popular-amenities ul li {
    width: 100%;
  } */

  .cancelbar .cancelbar-list .column p {
    font-size: 11px;
  }

  .progressbar li {
    font-size: 11px;
  }

  .timeline-item:after {
    border-width: 12px 0 12px 10px;
  }

  .timeline-item {
    height: 22px;
  }

  .timeline-item:before {
    clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 13px) 100%, 0 100%);
  }

  .timeline-title {
    top: -20px;
    font-size: 12px !important;
    margin: 0;
  }

  .popular-amenities ul.important-information-list li {
    width: 100%;
  }
}

.popular-amenities ul.important-information-list {
  padding-left: 16px;
}

.discounts-list .long_dis h5 span {
  color: #70d3ff;
  font-size: 17px;
  font-weight: 900;
  float: right;
}

.range-to-stay p {
  display: flex;
  align-items: center;
  gap: 10px;
}

.range-to-stay p img {
  width: 35px;
  height: 35px;
  background: #ddf4ff;
  padding: 8px;
  border-radius: 20px;
}

.range-to-stay p i, .air-condition span i {
  width: 35px;
  height: 35px;
  background: #ddf4ff;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.gap-30 {
  gap: 20px;
}

.info-icon {
  margin-left: 5px;
  font-size: 14px;
}

.tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: help;
}

.tooltip-text {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 4px;
  position: absolute;
  z-index: 9999;
  top: 125%;
  /* Show below the icon */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s, visibility 0.3s;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.guest-content .quantity .input-group .input-group-append .btn {
  height: 30px;
}
@media (max-width: 767px) {
  .flex-pricing-detail-box .timer.favorite-button-discount {
    top: 50px;
  }
}
</style>
